// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.92.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.92.0/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.92.0/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Assistant/Assistant-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Assistant/Assistant-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Assistant/Assistant-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Assistant/Assistant-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/Assistant/Assistant-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/Assistant/Assistant-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/Assistant/Assistant-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/OpenSans/OpenSans_Condensed-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/OpenSans/OpenSans_Condensed-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/OpenSans/OpenSans_Condensed-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/OpenSans/OpenSans_Condensed-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/OpenSans/OpenSans_Condensed-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/OpenSans/OpenSans_Condensed-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/OpenSans2/OpenSans-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/OpenSans2/OpenSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/OpenSans2/OpenSans-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/OpenSans2/OpenSans-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/OpenSans2/OpenSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/OpenSans2/OpenSans-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/Heebo/Heebo-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../fonts/Heebo/Heebo-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../fonts/Heebo/Heebo-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/Heebo/Heebo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/Heebo/Heebo-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../fonts/Heebo/Heebo-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../fonts/Heebo/Heebo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../fonts/Heebo/Heebo-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../fonts/almoni/ALMONI-TZAR-AAA-LIGHT.OTF", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../fonts/almoni/ALMONI-TZAR-AAA-REGULAR.OTF", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../fonts/almoni/ALMONI-TZAR-AAA-BOLD.OTF", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --background-color: white;
  --background-table-header: white;
  --text-table-header: white;
  --table-border-color: white;
  --color-primary: white;
  --color-secondary: white;
  --text-dark: white;
  --text-dark-secondary: white;
  --text-light: white;
  --small-border-radius: 4px;
  --big-border-radius: 4px;
  --light-box-shadow: 0px 0px 3px 0 #23394230;
}

/* Breakpoint mixins */
@keyframes flip {
  0% {
    margin-top: -360px;
  }
  5% {
    margin-top: -270px;
  }
  25% {
    margin-top: -270px;
  }
  30% {
    margin-top: -180px;
  }
  50% {
    margin-top: -180px;
  }
  55% {
    margin-top: -90px;
  }
  75% {
    margin-top: -90px;
  }
  80% {
    margin-top: 0px;
  }
  99.99% {
    margin-top: 0px;
  }
  100% {
    margin-top: -360px;
  }
}
@font-face {
  font-family: assistant;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 100;
}
@font-face {
  font-family: assistant;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 200;
}
@font-face {
  font-family: assistant;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-weight: 300;
}
@font-face {
  font-family: assistant;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-weight: 400;
}
@font-face {
  font-family: assistant;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-weight: 500;
}
@font-face {
  font-family: assistant;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-weight: 600;
}
@font-face {
  font-family: assistant;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-weight: 700;
}
@font-face {
  font-family: assistant;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-weight: 800;
}
@font-face {
  font-family: open-sans;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-weight: 100;
}
@font-face {
  font-family: open-sans;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-weight: 200;
}
@font-face {
  font-family: open-sans;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-weight: 300;
}
@font-face {
  font-family: open-sans;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-weight: 400;
}
@font-face {
  font-family: open-sans;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  font-weight: 500;
}
@font-face {
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  font-family: open-sans;
  font-weight: 600;
}
@font-face {
  font-family: open-sans;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  font-weight: 700;
}
@font-face {
  font-family: open-sans;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  font-weight: 800;
}
@font-face {
  font-family: open-sans2;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  font-weight: 100;
}
@font-face {
  font-family: open-sans2;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  font-weight: 200;
}
@font-face {
  font-family: open-sans2;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  font-weight: 300;
}
@font-face {
  font-family: open-sans2;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  font-weight: 400;
}
@font-face {
  font-family: open-sans2;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  font-weight: 500;
}
@font-face {
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  font-family: open-sans2;
  font-weight: 600;
}
@font-face {
  font-family: open-sans2;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  font-weight: 700;
}
@font-face {
  font-family: open-sans2;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  font-weight: 800;
}
@font-face {
  font-family: heebo;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  font-weight: 800;
}
@font-face {
  font-family: heebo;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  font-weight: 100;
}
@font-face {
  font-family: heebo;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  font-weight: 200;
}
@font-face {
  font-family: heebo;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  font-weight: 300;
}
@font-face {
  font-family: heebo;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  font-weight: 400;
}
@font-face {
  font-family: heebo;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  font-weight: 500;
}
@font-face {
  font-family: heebo;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  font-weight: 600;
}
@font-face {
  font-family: heebo;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  font-weight: 700;
}
@font-face {
  font-family: heebo;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  font-weight: 800;
}
@font-face {
  font-family: almoni;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  font-weight: 100;
}
@font-face {
  font-family: almoni;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  font-weight: 200;
}
@font-face {
  font-family: almoni;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  font-weight: 300;
}
@font-face {
  font-family: almoni;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  font-weight: 400;
}
@font-face {
  font-family: almoni;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  font-weight: 500;
}
@font-face {
  font-family: almoni;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  font-weight: 600;
}
@font-face {
  font-family: almoni;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  font-weight: 700;
}
@font-face {
  font-family: almoni;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  font-weight: 800;
}
.flex {
  display: flex;
}
.flex.column {
  flex-direction: column;
}
.flex.row {
  flex-direction: row;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-start {
  justify-content: flex-start;
}
.flex.justify-space-between {
  justify-content: space-between;
}
.flex.justify-space-around {
  justify-content: space-around;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-center {
  align-items: center;
}
.flex.align-start {
  align-items: flex-start;
}
.flex.align-end {
  align-items: flex-end;
}
.flex.gap-1 {
  gap: 1rem;
}
.flex.gap-0-5 {
  gap: 0.5rem;
}
.flex.gap-small {
  gap: 4px;
}
.flex .full {
  flex-grow: 1;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.w100 {
  width: 100%;
}

.h100 {
  height: 100%;
}

.site-block {
  margin-bottom: 1.25rem;
}

.oversight-container {
  background-color: white;
  width: 100%;
  border-radius: var(--big-border-radius);
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  box-shadow: #e0e0e0 0px 0.5rem 1.25rem;
  position: relative;
  padding: 12px;
}

.limit-plan {
  margin-top: 5px;
  padding: 20px;
  background-color: rgba(255, 204, 0, 0.1960784314);
  border-radius: var(--small-border-radius);
}

.explan {
  padding: 20px;
  padding-inline-end: 30px;
  background-color: rgba(169, 217, 240, 0.1960784314);
  border-radius: var(--small-border-radius);
  position: relative;
  gap: 30px;
}
.explan svg {
  font-size: 40px;
  opacity: 0.5;
}
.explan .close {
  position: absolute;
  right: 10px;
  top: 10px;
  background-color: transparent;
  border: none;
}

.main-container {
  display: grid;
  grid-template-columns: 20px 1fr 20px;
}
.main-container:has(> .page) {
  min-height: calc(100% - var(--footer-height) - var(--navbar-height));
}
.main-container > * {
  grid-column: 2;
}
.main-container > *.full {
  grid-column: 1/-1;
}
@media (min-width: 500px) {
  .main-container {
    grid-template-columns: minmax(20px, 1fr) minmax(auto, 460px) minmax(20px, 1fr);
  }
}
@media (min-width: 760px) {
  .main-container {
    grid-template-columns: minmax(20px, 1fr) minmax(auto, 720px) minmax(20px, 1fr);
  }
}
@media (min-width: 1240px) {
  .main-container {
    grid-template-columns: minmax(20px, 1fr) minmax(auto, 1200px) minmax(20px, 1fr);
  }
}

.page {
  height: 100%;
  padding-top: 40px;
  padding-bottom: 40px;
  position: relative;
}
.page .error {
  color: red;
}

*,
*::after,
*::before {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: heebo, Arial, Helvetica, sans-serif;
}

html {
  height: 100%;
}

button,
a {
  cursor: pointer;
}

body,
#root,
.App {
  height: 100%;
}

body {
  background-color: var(--background-color);
  font-size: 16px;
  color: var(--text-dark);
}

.button {
  border: none;
  padding: 4px 10px;
  font-size: 12px;
  border-radius: var(--small-border-radius);
  display: flex;
  align-items: center;
  gap: 4px;
  box-shadow: var(--light-box-shadow);
  white-space: nowrap;
}
.button:disabled {
  opacity: 0.5;
  pointer-events: none;
}
.button.primary {
  background-color: var(--color-primary);
  color: var(--text-light);
}

.table-container {
  border-radius: var(--small-border-radius);
}
.table-container button,
.table-container a {
  text-decoration: none;
  color: black;
  background-color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  box-shadow: var(--light-box-shadow);
  border-radius: var(--small-border-radius);
  margin-inline: auto;
  gap: 10px;
  width: max-content;
}
.table-container table.table {
  width: 100%;
  max-width: 100%;
  border-spacing: 0;
  border-collapse: none;
  background-color: white;
  display: table;
  border: 1px solid var(--table-border-color);
  border-radius: var(--small-border-radius);
  position: relative;
}
.table-container table.table .resizer {
  /* Displayed at the right side of column */
  position: absolute;
  top: 0;
  right: 0;
  width: 5px;
  cursor: col-resize;
  -webkit-user-select: none;
          user-select: none;
  z-index: 999;
}
.table-container table.table .resizer:hover,
.table-container table.table .resizing {
  border-right: 2px solid var(--navbar-color);
}
.table-container table.table .hide {
  display: none;
}
.table-container table.table thead {
  top: 0;
  background-color: var(--color-primary);
  color: var(--text-light);
  border-radius: var(--small-border-radius);
  /* Don't forget this, required for the stickiness */
}
.table-container table.table thead tr {
  border-radius: var(--small-border-radius);
}
.table-container table.table thead th:first-child {
  border-top-left-radius: var(--small-border-radius);
}
.table-container table.table thead th:last-child {
  border-top-right-radius: var(--small-border-radius);
}
.table-container table.table thead th {
  text-align: center;
  border-bottom: 1px solid var(--border-bottom);
  padding: 20px 8px;
  position: relative;
}
.table-container table.table thead th .arrow-button-container button {
  width: 20px;
  height: 11px;
  background-color: transparent;
  border: none;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.table-container table.table thead th .arrow-button-container button.curr {
  transform: scale(1.2);
}
.table-container table.table tr td {
  padding: 0 16px;
  display: table-cell;
  height: 60px;
  text-align: center;
  padding: 8px;
}
.table-container table.table tr td:not(:last-child) {
  border-right: 1px solid var(--table-border-color);
}
.table-container table.table tr:not(:first-child) td {
  border-top: 1px solid var(--table-border-color);
}
.table-container table.table tr:last-child {
  border-bottom-right-radius: var(--small-border-radius);
  border-bottom-left-radius: var(--small-border-radius);
}
.table-container table.table tr:last-child td:first-child {
  border-bottom-left-radius: var(--small-border-radius);
}
.table-container table.table tr:last-child td:last-child {
  border-bottom-right-radius: var(--small-border-radius);
}
.table-container table.table .options button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 5px 0 0;
  aspect-ratio: 1/1;
  width: 35px;
  font-size: 15px;
}
.table-container table.table tbody td {
  max-width: 100px;
}
.table-container table.table tbody td .three-dots {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.table-container:has(.paginator) table.table {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.table-container:has(.paginator) table.table tr:last-child {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.table-container:has(.paginator) table.table tr:last-child td:first-child {
  border-bottom-left-radius: 0;
}
.table-container:has(.paginator) table.table tr:last-child td:last-child {
  border-bottom-right-radius: 0;
}
.table-container .table-checkbox {
  width: 30px;
}
.table-container .table-checkbox .checkbox-container {
  width: 30px;
  text-align: center;
}
.table-container .table-checkbox label:before {
  margin: 0 !important;
}
.table-container .paginator {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background-color: white;
  border-bottom-left-radius: var(--small-border-radius);
  border-bottom-right-radius: var(--small-border-radius);
  border-bottom: 1px solid var(--table-border-color);
  border-right: 1px solid var(--table-border-color);
  border-left: 1px solid var(--table-border-color);
}
.table-container .paginator span {
  color: var(--color-primary);
  font-weight: bold;
}
.table-container .paginator .page {
  border-radius: var(--small-border-radius);
  background-color: var(--color-primary);
  padding: 5px;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin: 0;
  cursor: pointer;
}
.table-container .paginator .page.curr {
  font-weight: var(--bold);
  transform: scale(1.2);
}

.date-picker-container {
  position: relative;
  width: max-content;
}
.date-picker-container .range-picker-toggle {
  height: 33px;
  display: flex;
  gap: 10px;
  align-items: center;
  border: none;
  border-radius: var(--small-border-radius);
  background-color: rgb(255, 255, 255);
  box-shadow: var(--light-box-shadow);
  border: 1px solid transparent;
  padding: 0 10px;
  color: var(--text-dark-secondary);
}
.date-picker-container .refresh-button {
  border: none;
  background-color: transparent;
  color: var(--color-secondary);
}
.date-picker-container .refresh-button:disabled {
  pointer-events: none;
  opacity: 0.3;
}
.date-picker-container .range-picker {
  position: absolute;
  z-index: 999999;
  left: 0;
  bottom: 0;
  transition: 300ms ease-in-out;
  transform-origin: left top;
  box-shadow: var(--light-box-shadow);
  border-radius: var(--small-border-radius);
  overflow: hidden;
  background-color: white;
  padding-block-end: 10px;
}
.date-picker-container .range-picker .save-dates {
  margin-inline: 10px;
}
.date-picker-container .range-picker.close {
  transform: translateY(calc(100% + 5px)) scale(0);
}
.date-picker-container .range-picker.open {
  transform: translateY(calc(100% + 5px)) scale(1);
}
.date-picker-container .range-picker .rdrDayNumber {
  transform: translatey(-5px);
}
.date-picker-container .range-picker .rdrDayNumber span:after {
  transform: translate(-50%, 6px);
}

:root {
  --indicator-color: var(--color-primary);
  --navbar-color: var(--color-secondary);
  --navbar-height: 80px;
  --svg-width: calc(var(--navbar-height) * 0.34);
  --text-font-size: calc(var(--navbar-height) * 0.17);
  --icon-translate-y: calc(var(--navbar-height) * 0.48);
}

.navbar-wrapper {
  height: var(--navbar-height);
  background-color: var(--color-secondary);
}
.navbar-wrapper .shop-name {
  color: var(--text-light);
  font-weight: 600;
  font-size: 20px;
}

.navbar-container {
  width: 100%;
  height: var(--navbar-height);
  position: relative;
  background-color: var(--navbar-color);
  display: flex;
  align-items: center;
  top: 0;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
}
.navbar-container img {
  height: var(--navbar-height);
  padding: 15px;
}
.navbar-container .sense-app {
  display: flex;
  flex-direction: row-reverse;
  gap: 10px;
}
.navbar-container .sense-app a {
  border: none;
  padding: 4px 10px;
  font-size: 12px;
  border-radius: var(--small-border-radius);
  display: flex;
  align-items: center;
  gap: 4px;
  box-shadow: var(--light-box-shadow);
  white-space: nowrap;
  background-color: var(--color-primary);
  color: var(--text-light);
  text-decoration: none;
}
.navbar-container .list {
  display: flex;
  width: 100%;
}
.navbar-container .list li {
  position: relative;
  list-style: none;
  width: var(--navbar-height);
  height: var(--navbar-height);
  z-index: 1;
}
.navbar-container .list li a {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  text-align: center;
}
.navbar-container .list li a .icon {
  position: relative;
  display: block;
  text-align: center;
  transition: 0.5s;
  color: var(--text-light);
  display: flex;
  align-items: center;
  justify-content: center;
  height: var(--navbar-height);
}
.navbar-container .list li a .icon svg {
  fill: currentColor;
  width: var(--svg-width);
  height: var(--svg-width);
}
.navbar-container .list li a .text {
  position: absolute;
  color: var(--background-color);
  color: var(--text-light);
  font-weight: 400;
  font-size: var(--text-font-size);
  letter-spacing: 0.05rem;
  transition: 0.5s;
  opacity: 0;
  transform: translateY(-25px);
}
.navbar-container .list li a.active .icon {
  transform: translateY(var(--icon-translate-y));
  color: var(--background-color);
}
.navbar-container .list li a.active .text {
  opacity: 1;
  transform: translateY(-15px);
}
.navbar-container .list li:nth-child(1):has(.active) ~ .indicator {
  transform: translateX(calc(var(--navbar-height) * (1 - 1)));
}
.navbar-container .list li:nth-child(2):has(.active) ~ .indicator {
  transform: translateX(calc(var(--navbar-height) * (2 - 1)));
}
.navbar-container .list li:nth-child(3):has(.active) ~ .indicator {
  transform: translateX(calc(var(--navbar-height) * (3 - 1)));
}
.navbar-container .indicator {
  position: absolute;
  width: var(--navbar-height);
  height: var(--navbar-height);
  background-color: var(--indicator-color);
  bottom: -50%;
  border-radius: 50%;
  border: 6px solid var(--background-color);
  transition: 0.5s;
}
.navbar-container .indicator::before, .navbar-container .indicator::after {
  content: "";
  position: absolute;
  bottom: 50%;
  width: 20px;
  height: 20px;
  background-color: transparent;
}
.navbar-container .indicator::before {
  left: -22px;
  box-shadow: 1px 10px 0 0 var(--background-color);
  border-bottom-right-radius: 20px;
}
.navbar-container .indicator::after {
  right: -22px;
  box-shadow: -1px 10px 0 0 var(--background-color);
  border-bottom-left-radius: 20px;
}

.whatsapp {
  position: fixed;
  bottom: 50px;
  right: 50px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #25D366;
  border-radius: 50%;
  color: white;
  font-size: 30px;
}

.input-container {
  position: relative;
  width: 100%;
  font-size: 17px;
  padding-top: var(--label-hight);
  padding-top: var(--label-hight);
}
.input-container input {
  width: 100%;
  padding: var(--input-padding);
  border: 1px solid var(--table-border-color);
  border-radius: var(--small-border-radius);
  outline: none;
  transition: all 150ms ease-in-out;
}
.input-container input.disabled + label, .input-container input:valid + label, .input-container input:focus + label {
  top: 0;
  color: var(--text-dark);
  font-weight: var(--bold);
  font-size: var(--label-hight);
  padding: 0 5px;
}
.input-container .timezone-container {
  width: -moz-fit-content;
  width: fit-content;
}
.input-container .timezone-select {
  font-size: 14px;
  max-width: 400px;
  padding: 2px 10px;
  border: 1px solid var(--table-border-color);
  border-radius: var(--small-border-radius);
  outline: none;
  transition: all 150ms ease-in-out;
}
.input-container .timezone-select.disabled + label, .input-container .timezone-select:valid + label, .input-container .timezone-select:focus + label {
  top: 0;
  color: var(--text-dark);
  font-weight: var(--bold);
  font-size: var(--label-hight);
  padding: 0 5px;
}
.input-container .timezone-option {
  font-size: 14px;
}
.input-container .timezone-dropdownIndicator {
  padding: 4px;
}
.input-container label {
  padding: var(--input-padding);
  position: absolute;
  width: 100%;
  left: 0;
  text-align: start;
  cursor: text;
  transition: all 150ms ease-in-out;
  color: var(--text-dark-secondary);
  top: var(--label-hight);
  z-index: 2;
}

.loader {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  margin: 0 auto;
}
.loader div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid var(--color-primary);
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: var(--color-primary) transparent transparent transparent;
}
.loader div:nth-child(1) {
  animation-delay: -0.45s;
}
.loader div:nth-child(2) {
  animation-delay: -0.3s;
}
.loader div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
footer {
  text-align: center;
  background-color: var(--color-secondary);
  justify-self: flex-end;
  height: var(--footer-height);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}
footer a {
  color: white;
  text-decoration: none;
}

.loader-page {
  min-height: calc(100% - var(--footer-height));
  text-align: center;
}

.switch input[type=checkbox] {
  opacity: 0;
  position: absolute;
  transform: scale(0);
}
.switch input[type=checkbox]:disabled + label {
  opacity: 0.5;
}
.switch input[type=checkbox]:focus + label::before {
  box-shadow: var(--light-box-shadow);
}
.switch input[type=checkbox] + label {
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
}
.switch input[type=checkbox] + label::before, .switch input[type=checkbox] + label::after {
  content: "";
  border-radius: 1.5em;
  transition: all 150ms ease-in-out;
}
.switch input[type=checkbox] + label::before {
  width: 4em;
  height: 2em;
  background-color: var(--color-primary);
  margin-inline-end: 0.25em;
}
.switch input[type=checkbox] + label::after {
  width: 1.8em;
  height: 1.8em;
  left: 0.2em;
  background-color: var(--color-secondary);
  position: absolute;
}
.switch input[type=checkbox]:checked + label::before {
  background-color: var(--color-secondary);
}
.switch input[type=checkbox]:checked + label::after {
  background-color: var(--color-primary);
  transform: translateX(100%);
}

.tooltip-container {
  --icon-width: 15px;
  --arrow-size: 10px;
  --scale: 0;
  --text-secondary-color: white;
  --info: #242425;
  --gap: 5px;
  background-color: var(--info);
  position: relative;
  display: inline-block;
  width: var(--icon-width);
  height: var(--icon-width);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: var(--text-secondary-color);
}
.tooltip-container svg {
  font-size: 10px;
}
.tooltip-container::before {
  content: "";
  position: absolute;
  border: var(--arrow-size) solid transparent;
  right: 50%;
}
.tooltip-container .tooltip {
  border-radius: var(--small-border-radius);
  padding: var(--gap);
  background-color: var(--info);
  position: absolute;
  transform: scale(var(--scale));
  max-width: 300px;
  width: max-content;
  z-index: 999;
  text-align: center;
  font-size: 16px;
}
.tooltip-container.center .tooltip {
  left: 50%;
  transform: translateX(-50%) scale(var(--scale));
}
.tooltip-container.right .tooltip {
  right: 0;
  transform: scale(var(--scale));
}
.tooltip-container.left .tooltip {
  left: 0;
  transform: scale(var(--scale));
}
.tooltip-container.bottom::before {
  transform: translateX(50%) translateY(calc(5px + var(--arrow-size))) scale(var(--scale));
  bottom: 0;
  border-bottom-color: var(--info);
}
.tooltip-container.bottom .tooltip {
  top: calc(var(--icon-width) + 5px + var(--arrow-size));
}
.tooltip-container.top::before {
  transform: translateX(50%) translateY(calc(-5px - var(--arrow-size))) scale(var(--scale));
  top: 0;
  border-top-color: var(--info);
}
.tooltip-container.top .tooltip {
  bottom: calc(var(--icon-width) + 5px + var(--arrow-size));
}
.tooltip-container.top, .tooltip-container.bottom {
  --scale: 1;
}

.select {
  position: relative;
  min-width: 20em;
  width: 100%;
  min-height: 1.5em;
  border: 1px solid var(--light-grey);
  display: flex;
  align-items: center;
  gap: 0.5em;
  padding: 0.5em;
  border-radius: var(--small-border-radius);
  outline: none;
  margin-top: calc(var(--label-hight) + 2px);
}
.select*:focus {
  border-color: var(--primary-color);
}
.select .value {
  flex-grow: 1;
  display: flex;
  gap: 0.5em;
  flex-wrap: wrap;
}
.select .filter-input,
.select .placeholder {
  border: none;
  outline: none;
  flex-grow: 1;
  display: flex;
  gap: 0.5em;
  flex-wrap: wrap;
}
.select .placeholder {
  opacity: 0.5;
  position: absolute;
  transition: all var(--animation-duration) var(--animation-timing-curve);
  top: 0.7rem;
}
.select .placeholder.top {
  top: calc(var(--label-hight) * -1 - 2px);
  font-size: var(--label-hight);
  font-weight: var(--bold);
  opacity: 1;
}
.select .clear-btn {
  background: none;
  color: var(--light-grey);
  border: none;
  outline: none;
  cursor: pointer;
  padding: 0;
  font-size: 1.25em;
}
.select .clear-btn:hover, .select .clear-btn:focus {
  color: var(--medium-grey);
}
.select .divider {
  background-color: var(--light-grey);
  align-self: stretch;
  width: 0.05em;
}
.select .caret {
  translate: 0 25%;
  border: 0.25em solid transparent;
  border-top-color: var(--light-grey);
}
.select .options {
  position: absolute;
  margin: 0;
  padding: 0;
  list-style: none;
  display: none;
  max-height: 15em;
  overflow-y: auto;
  border: 0.05em solid var(--light-grey);
  border-radius: 0.25em;
  width: 100%;
  left: 0;
  top: calc(100% + 0.25em);
  background-color: white;
  z-index: 100;
}
.select .options.show {
  display: block;
}
.select .options .option {
  padding: 0.25em 0.5em;
  cursor: pointer;
}
.select .options .option.selected {
  background-color: hsl(200, 100%, 70%);
}
.select .options .option.highlighted {
  background-color: hsl(200, 100%, 50%);
  color: white;
}
.select .selected-option {
  display: flex;
  align-items: center;
  border: 0.05em solid var(--light-grey);
  border-radius: 0.25em;
  padding: 0.15em 0.25em;
  gap: 0.25em;
  cursor: pointer;
  background: none;
  outline: none;
}
.select .selected-option > .remove-btn {
  font-size: 1.25em;
  color: var(--light-grey);
}
.select .selected-option:hover, .select .selected-option:focus {
  background-color: hsl(0, 100%, 90%);
  border-color: hsl(0, 100%, 50%);
}
.select .selected-option:hover > .remove-btn, .select .selected-option:focus > .remove-btn {
  color: hsl(0, 100%, 50%);
}

.dropdown-container {
  position: relative;
  width: max-content;
}
.dropdown-container .toggele-dropdown-button {
  border: none;
  background-color: white;
  padding: 10px;
  box-shadow: var(--light-box-shadow);
  border-radius: var(--small-border-radius);
}
.dropdown-container .toggele-dropdown-button:has(.text) {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.dropdown-container .dropdown {
  position: absolute;
  padding: 9px 0;
  max-width: 340px;
  min-width: 200px;
  background-color: white;
  box-shadow: var(--light-box-shadow);
  top: 100%;
  left: 0;
  z-index: 10;
  border-radius: var(--small-border-radius);
  transform: scale(0);
  transition: transform var(--animation-duration) var(--animation-timing-curve);
  transform-origin: top left;
}
.dropdown-container .dropdown.open {
  transform: scale(1);
}
.dropdown-container .dropdown .menu-item {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 14.5px;
  width: 100%;
  padding: 10px 10px;
  text-align: start;
  border: none;
  background-color: transparent;
  cursor: pointer;
  text-transform: capitalize;
}
.dropdown-container .dropdown .menu-item:hover {
  background-color: rgba(0, 0, 0, 0.2);
}

.checkbox-container {
  display: flex;
  align-items: center;
  position: relative;
  --light-grey: #999;
  --primary-color: #fe7900;
  --lightest-grey: #fff;
}
.checkbox-container label {
  cursor: pointer;
  display: flex;
}
.checkbox-container label::before {
  content: "";
  width: 1em;
  height: 1em;
  border-radius: var(--small-border-radius);
  margin-right: 0.5em;
  border: 0.05em solid var(--light-grey);
}
.checkbox-container label:hover::before,
.checkbox-container input[type=checkbox]:hover + label::before {
  background-color: var(--primary-color);
  border: 1px solid var(--primary-color);
}
.checkbox-container input[type=checkbox] {
  cursor: pointer;
  opacity: 0;
  position: absolute;
}
.checkbox-container input[type=checkbox]:focus + label::before {
  box-shadow: var(--light-box-shadow);
}
.checkbox-container input[type=checkbox]:disabled, .checkbox-container input[type=checkbox]:disabled + label {
  color: var(--light-grey);
  cursor: default;
}
.checkbox-container input[type=checkbox]:disabled::before, .checkbox-container input[type=checkbox]:disabled + label::before {
  background-color: var(--lightest-grey);
  border-color: #999;
}
.checkbox-container input[type=checkbox]:checked + label::after {
  content: "";
  position: absolute;
  left: 10px;
  width: 12px;
  height: 6px;
  border-bottom: 3px solid var(--lightest-grey);
  border-left: 3px solid var(--lightest-grey);
  transform: translate(2px, 4px) rotate(-45deg);
  border-radius: var(--small-border-radius);
}
.checkbox-container input[type=checkbox]:checked + label::before {
  background-color: var(--primary-color);
  border: 1px solid var(--primary-color);
}

.notifications-container {
  position: fixed;
  z-index: 10;
  right: 10px;
  top: 90px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  --error: #ff0000;
  --warning: #ff9f00;
  --success: #00ff00;
}
.notifications-container .notification {
  text-align: start;
  padding: 1rem;
  color: white;
  border-radius: var(--small-border-radius);
  width: 300px;
  box-shadow: var(--dark-box-shadow);
  display: flex;
  gap: 16px;
  align-items: flex-start;
}
.notifications-container .notification svg {
  color: white;
  font-size: 2rem;
  margin-top: 4px;
}
.notifications-container .notification .content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: start;
}
.notifications-container .notification .content .title {
  font-weight: var(--bold);
  text-align: start;
}
.notifications-container .notification.error {
  background-color: var(--error);
}
.notifications-container .notification.warning {
  background-color: var(--warning);
}
.notifications-container .notification.success {
  background-color: var(--success);
}
.notifications-container .notification.info {
  background-color: var(--info);
}

.context-menu-container {
  position: fixed;
  padding: 9px 0;
  max-width: 340px;
  min-width: 200px;
  background-color: white;
  box-shadow: var(--light-box-shadow);
  top: 0;
  left: 0;
  z-index: 10;
  padding: 10px;
  border-radius: var(--big-border-radius);
  animation-name: show;
  animation-duration: 150ms;
  max-height: 300px;
  overflow-y: auto;
}
.context-menu-container .menu-item {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 14.5px;
  width: 100%;
  padding: 10px 10px;
  text-align: start;
  border: none;
  background-color: transparent;
  display: block;
}

@keyframes show {
  from {
    scale: 0;
  }
  to {
    scale: 1;
  }
}
.accordion {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.accordion .accordion-item {
  padding: 10px 20px;
  background-color: white;
  border-radius: var(--big-border-radius);
}
.accordion .accordion-item.open .title svg {
  transform: rotate(225deg);
}
.accordion .accordion-item.open .content {
  max-height: 9999px;
  font-size: 1rem;
  opacity: 1;
  padding: 10px 0;
}
.accordion .accordion-item .title {
  font-weight: var(--bold);
  font-size: 1.5rem;
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.accordion .accordion-item .title svg {
  transition: transform 150ms ease-in-out;
}
.accordion .accordion-item .content {
  word-break: keep-all;
  max-height: 0;
  transition: all 150ms ease-in-out;
  overflow: hidden;
  font-size: 0;
  opacity: 0;
  padding: 0;
}

#root {
  overflow-y: overlay;
}

.modal {
  margin: auto;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.modal-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.7333333333);
  align-items: center;
  justify-content: center;
  overflow-y: hidden;
  z-index: 1001;
  transition: 0.2s;
  display: none;
}
.modal-backdrop.show {
  display: flex;
}

.modal.enter-done {
  opacity: 1;
  pointer-events: visible;
}

.modal.exit {
  opacity: 0;
}

.modal-content {
  width: 500px;
  padding: 10px;
  border-radius: var(--big-border-radius);
  font-size: 20px;
  align-items: center;
  background-color: white;
  box-shadow: var(--light-box-shadow);
}

.modal.enter-done .modal-content {
  transform: translateY(0);
}

.modal.exit .modal-content {
  transform: translateY(-200px);
}

.modal-header,
.modal-footer {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-header .close-modal,
.modal-footer .close-modal {
  cursor: pointer;
  font-size: 20px;
  color: var(--primary-color);
}
.modal-header > button,
.modal-footer > button {
  padding: 10px;
  gap: 10px;
  align-items: center;
}

.modal-title {
  margin: 0;
}

.modal-body {
  padding: 10px;
  border-top: 1px solid #eee;
  text-align: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.modal-body > button {
  padding: 10px;
  gap: 10px;
  align-items: center;
}

.dashboard-page .title {
  display: block;
  padding-bottom: 10px;
  font-weight: 600;
}
.dashboard-page .placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: var(--small-border-radius);
}
.dashboard-page .placeholder svg {
  width: 130px;
  height: 130px;
  background-color: var(--background-color);
  margin-bottom: 20px;
  padding: 40px;
  border-radius: 50%;
  color: var(--text-dark-secondary);
}
.dashboard-page .placeholder span {
  color: var(--text-dark);
}
.dashboard-page .placeholder span.error {
  color: red;
}
.dashboard-page .custom-tooltip {
  background-color: white;
  padding: 10px;
  max-width: 200px;
}
.dashboard-page .custom-tooltip .content {
  word-break: break-all;
}
.dashboard-page .areaMultiLine-container {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.no-shop-page {
  font-size: 2rem;
}
.no-shop-page img {
  max-width: 300px;
}
.no-shop-page span {
  text-align: center;
}

.main-container:has(> .page.no-shop-page) {
  min-height: calc(100% - var(--footer-height));
}

.plans-page .wa-container {
  position: relative;
}
.plans-page .pay-time-container {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 1rem;
  align-items: center;
}
.plans-page .pay-time-container span:nth-child(1) {
  text-align: end;
}
.plans-page .pay-time-container .monthly {
  font-weight: 600;
}
.plans-page .pay-time-container .yearly {
  font-weight: 600;
}
.plans-page .plans-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 2rem;
  position: relative;
  padding: 1rem 3rem;
}
.plans-page .plans-container .black-friday {
  background-color: #000;
  color: #fff;
}
.plans-page .plans-container .plan {
  position: relative;
  z-index: 1;
  box-shadow: var(--light-box-shadow);
  padding: 24px;
  border-radius: var(--big-border-radius);
  padding-top: 80px;
}
.plans-page .plans-container .plan .title {
  display: block;
  font-size: 1.7rem;
  font-weight: 800;
  margin-bottom: 0.2rem;
  text-transform: capitalize;
}
.plans-page .plans-container .plan .title.free {
  margin-bottom: 37px;
}
.plans-page .plans-container .plan .price-mo {
  display: block;
  font-weight: 600;
  color: var(--color-primary);
}
.plans-page .plans-container .plan .price-mo .price {
  font-size: 1.5rem;
}
.plans-page .plans-container .plan .plan-btn {
  background-color: var(--color-primary);
  width: 100%;
  font-size: 1.2rem;
  color: white;
  font-weight: 600;
  border-radius: var(--big-border-radius);
  border: none;
  padding: 0.7rem;
  margin: 1rem 0;
}
.plans-page .plans-container .plan .yearly-price {
  width: 100%;
  display: block;
  text-align: center;
  margin-top: 1rem;
  font-size: 0.8rem;
  color: var(--text-dark-secondary);
}
.plans-page .plans-container .plan .yearly-price .price {
  font-size: 1rem;
}
.plans-page .plans-container .plan .features {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.plans-page .plans-container .plan .features .feature {
  position: relative;
  padding-left: 35px;
}
.plans-page .plans-container .plan .features .feature:after {
  content: "";
  display: block;
  position: absolute;
  top: -1px;
  left: 10px;
  width: 8px;
  height: 16px;
  border: solid var(--color-primary);
  border-width: 0 4px 4px 0;
  transform: rotate(45deg);
  border-radius: 0.29rem;
}
.plans-page .plans-container .plan.curr {
  position: relative;
}
.plans-page .plans-container .plan.curr .plan-btn {
  background-color: transparent;
  color: var(--wa-text-primary);
  pointer-events: none;
}
.plans-page .plans-container .plan.curr::before {
  content: "CURRENT";
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  height: 50px;
  background-color: var(--color-primary);
  border-top-left-radius: var(--big-border-radius);
  border-top-right-radius: var(--big-border-radius);
  color: white;
}
.plans-page .plans-container .plan.most-popular {
  position: relative;
}
.plans-page .plans-container .plan.most-popular::before {
  content: "MOST POPULAR";
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  height: 50px;
  background-color: var(--color-secondary);
  border-top-left-radius: var(--big-border-radius);
  border-top-right-radius: var(--big-border-radius);
  color: white;
}
.plans-page .plans-container .plan.black-friday {
  position: relative;
}
.plans-page .plans-container .plan.black-friday::before {
  content: "BLACK FRIDAY";
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  height: 50px;
  background-color: var(--color-secondary);
  border-top-left-radius: var(--big-border-radius);
  border-top-right-radius: var(--big-border-radius);
  color: 0;
  background-color: var(--color-primary);
}

.home-page .totals-utm {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
}
.home-page .totals-utm .container {
  padding: 10px;
  border-radius: var(--big-border-radius);
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 20px;
  align-items: center;
  background-color: white;
  box-shadow: var(--light-box-shadow);
}
.home-page .totals-utm .container span:nth-child(1) {
  font-weight: 600;
}
.home-page .filters {
  width: 100%;
}
.home-page .filters .date-picker-with-button {
  position: static;
  padding-top: 12px;
}
.home-page .filters .search-container {
  display: flex;
  position: relative;
  min-width: 310px;
}
.home-page .filters .search-container .input-container label {
  padding-inline-start: 40px;
}
.home-page .filters .search-container .input-container input {
  border-radius: var(--big-border-radius);
  padding-inline-start: 40px;
}
.home-page .filters .search-container .svg-container {
  position: absolute;
  left: 10px;
  z-index: 10;
  top: 50%;
  transform: translateY(calc(-50% + 6px));
}
.home-page .table-tooltip {
  position: absolute;
  background-color: var(--color-secondary);
  color: var(--text-light);
  padding: 10px;
  left: 50%;
  opacity: 0;
  pointer-events: none;
  z-index: 100;
  top: -10px;
  transform: translateY(-100%) translateX(-50%);
  flex-direction: column;
  align-items: flex-start;
  border-radius: var(--small-border-radius);
  display: none;
}
.home-page .table-tooltip.show {
  display: flex;
}
.home-page .table-tooltip::before {
  content: "";
  position: absolute;
  bottom: -10px;
  border: 5px solid transparent;
  border-top-color: var(--color-secondary);
  left: calc(50% - 5px);
}
.home-page .export {
  padding: 10px;
  gap: 10px;
  align-items: center;
  background-color: white;
}
.home-page td:has(.table-tooltip) {
  overflow: unset !important;
  position: relative;
}
.home-page td:has(.table-tooltip):hover .table-tooltip {
  opacity: 1;
}

.order-page .orders-utm {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
}
.order-page .orders-utm .container {
  padding: 10px;
  border-radius: var(--big-border-radius);
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 20px;
  align-items: center;
  background-color: white;
  box-shadow: var(--light-box-shadow);
}
.order-page .orders-utm .container span:nth-child(1) {
  font-weight: 600;
}
.order-page .back {
  text-decoration: none;
  color: black;
  background-color: var(--color-primary);
  border: none;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  box-shadow: var(--light-box-shadow);
  border-radius: var(--small-border-radius);
  gap: 10px;
  width: max-content;
}

.instructions {
  font-size: 24px;
}
.instructions .oversight-container {
  padding: 12px 100px;
}
.instructions .oversight-container .list-and-image {
  gap: 50px;
}
.instructions .oversight-container .title {
  font-size: 60px;
  font-weight: 600;
  text-align: center;
  padding-bottom: 50px;
  color: var(--color-primary);
}
.instructions .oversight-container img {
  width: 30%;
  object-fit: contain;
}
.instructions .oversight-container ol {
  padding-inline-start: 25px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  font-weight: 300;
}

.button {
  border: none;
  padding: 4px 10px;
  font-size: 12px;
  border-radius: var(--small-border-radius);
  display: flex;
  align-items: center;
  gap: 4px;
  box-shadow: var(--light-box-shadow);
  white-space: nowrap;
  background-color: var(--color-primary);
  color: var(--text-light);
  text-decoration: none;
}

button,
a {
  cursor: pointer;
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/style/setup/variables.scss","webpack://./src/assets/style/global.scss","webpack://./src/assets/style/setup/mixins.scss","webpack://./src/assets/style/setup/animations.scss","webpack://./src/assets/style/setup/typography.scss","webpack://./src/assets/style/basics/helpers.scss","webpack://./src/assets/style/basics/layout.scss","webpack://./src/assets/style/basics/base.scss","webpack://./src/assets/style/components/table.scss","webpack://./src/assets/style/components/date-picker-container.scss","webpack://./src/assets/style/components/navbar.scss","webpack://./src/assets/style/components/input.scss","webpack://./src/assets/style/components/loader.scss","webpack://./src/assets/style/components/footer.scss","webpack://./src/assets/style/components/loader-page.scss","webpack://./src/assets/style/components/switch.scss","webpack://./src/assets/style/components/tooltip.scss","webpack://./src/assets/style/components/select.scss","webpack://./src/assets/style/components/dropdown.scss","webpack://./src/assets/style/components/checkbox.scss","webpack://./src/assets/style/components/notifications.scss","webpack://./src/assets/style/components/context-menu.scss","webpack://./src/assets/style/components/accordion.scss","webpack://./src/assets/style/components/modal.scss","webpack://./src/assets/style/pages/dashboard.scss","webpack://./src/assets/style/pages/no-shop.scss","webpack://./src/assets/style/pages/plans.scss","webpack://./src/assets/style/pages/home.scss","webpack://./src/assets/style/pages/orders.scss"],"names":[],"mappings":"AAAA;EAEI,yBAAA;EACA,gCAAA;EACA,0BAAA;EACA,2BAAA;EACA,sBAAA;EACA,wBAAA;EACA,kBAAA;EACA,4BAAA;EACA,mBAAA;EACA,0BAAA;EACA,wBAAA;EACA,2CAAA;ACAJ;;ACbA,sBAAA;ACAA;EACI;IACI,kBAAA;EFiBN;EEdE;IACI,kBAAA;EFgBN;EEbE;IACI,kBAAA;EFeN;EEZE;IACI,kBAAA;EFcN;EEXE;IACI,kBAAA;EFaN;EEVE;IACI,iBAAA;EFYN;EETE;IACI,iBAAA;EFWN;EERE;IACI,eAAA;EFUN;EEPE;IACI,eAAA;EFSN;EENE;IACI,kBAAA;EFQN;AACF;AG/CA;EACI,sBAAA;EACA,4CAAA;EACA,gBAAA;AHiDJ;AG/CE;EACE,sBAAA;EACA,4CAAA;EACA,gBAAA;AHiDJ;AG/CE;EACE,sBAAA;EACA,4CAAA;EACA,gBAAA;AHiDJ;AG/CE;EACE,sBAAA;EACA,4CAAA;EACA,gBAAA;AHiDJ;AG/CE;EACE,sBAAA;EACA,4CAAA;EACA,gBAAA;AHiDJ;AG/CE;EACE,sBAAA;EACA,4CAAA;EACA,gBAAA;AHiDJ;AG/CE;EACE,sBAAA;EACA,4CAAA;EACA,gBAAA;AHiDJ;AG/CE;EACE,sBAAA;EACA,4CAAA;EACA,gBAAA;AHiDJ;AG9CE;EACE,sBAAA;EACA,4CAAA;EACA,gBAAA;AHgDJ;AG9CE;EACE,sBAAA;EACA,4CAAA;EACA,gBAAA;AHgDJ;AG9CE;EACE,sBAAA;EACA,4CAAA;EACA,gBAAA;AHgDJ;AG9CE;EACE,sBAAA;EACA,4CAAA;EACA,gBAAA;AHgDJ;AG9CE;EACE,sBAAA;EACA,4CAAA;EACA,gBAAA;AHgDJ;AG9CE;EACE,6CAAA;EACA,sBAAA;EACA,gBAAA;AHgDJ;AG9CE;EACE,sBAAA;EACA,6CAAA;EACA,gBAAA;AHgDJ;AG9CE;EACE,sBAAA;EACA,6CAAA;EACA,gBAAA;AHgDJ;AG7CE;EACE,uBAAA;EACA,6CAAA;EACA,gBAAA;AH+CJ;AG7CE;EACE,uBAAA;EACA,6CAAA;EACA,gBAAA;AH+CJ;AG7CE;EACE,uBAAA;EACA,6CAAA;EACA,gBAAA;AH+CJ;AG7CE;EACE,uBAAA;EACA,6CAAA;EACA,gBAAA;AH+CJ;AG7CE;EACE,uBAAA;EACA,6CAAA;EACA,gBAAA;AH+CJ;AG7CE;EACE,6CAAA;EACA,uBAAA;EACA,gBAAA;AH+CJ;AG7CE;EACE,uBAAA;EACA,6CAAA;EACA,gBAAA;AH+CJ;AG7CE;EACE,uBAAA;EACA,6CAAA;EACA,gBAAA;AH+CJ;AG5CE;EACE,kBAAA;EACA,6CAAA;EACA,gBAAA;AH8CJ;AG1CE;EACE,kBAAA;EACA,6CAAA;EACA,gBAAA;AH4CJ;AG1CE;EACE,kBAAA;EACA,6CAAA;EACA,gBAAA;AH4CJ;AG1CE;EACE,kBAAA;EACA,6CAAA;EACA,gBAAA;AH4CJ;AG1CE;EACE,kBAAA;EACA,6CAAA;EACA,gBAAA;AH4CJ;AG1CE;EACE,kBAAA;EACA,6CAAA;EACA,gBAAA;AH4CJ;AG1CE;EACE,kBAAA;EACA,6CAAA;EACA,gBAAA;AH4CJ;AG1CE;EACE,kBAAA;EACA,6CAAA;EACA,gBAAA;AH4CJ;AG1CE;EACE,kBAAA;EACA,6CAAA;EACA,gBAAA;AH4CJ;AGxCE;EACE,mBAAA;EACA,6CAAA;EACA,gBAAA;AH0CJ;AGxCE;EACE,mBAAA;EACA,6CAAA;EACA,gBAAA;AH0CJ;AGxCE;EACE,mBAAA;EACA,6CAAA;EACA,gBAAA;AH0CJ;AGxCE;EACE,mBAAA;EACA,6CAAA;EACA,gBAAA;AH0CJ;AGxCE;EACE,mBAAA;EACA,6CAAA;EACA,gBAAA;AH0CJ;AGxCE;EACE,mBAAA;EACA,6CAAA;EACA,gBAAA;AH0CJ;AGxCE;EACE,mBAAA;EACA,6CAAA;EACA,gBAAA;AH0CJ;AGxCE;EACE,mBAAA;EACA,6CAAA;EACA,gBAAA;AH0CJ;AI5PA;EACI,aAAA;AJ8PJ;AI5PI;EACI,sBAAA;AJ8PR;AI3PI;EACI,mBAAA;AJ6PR;AI1PI;EACI,uBAAA;AJ4PR;AIzPI;EACI,2BAAA;AJ2PR;AIxPI;EACI,8BAAA;AJ0PR;AIvPI;EACI,6BAAA;AJyPR;AItPI;EACI,yBAAA;AJwPR;AIrPI;EACI,mBAAA;AJuPR;AIpPI;EACI,uBAAA;AJsPR;AInPI;EACI,qBAAA;AJqPR;AIlPI;EACI,SAAA;AJoPR;AIjPI;EACI,WAAA;AJmPR;AIhPI;EACI,QAAA;AJkPR;AI/OI;EACI,YAAA;AJiPR;;AI7OA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AJgPJ;;AI5OA;EACI,WAAA;AJ+OJ;;AI5OA;EACI,YAAA;AJ+OJ;;AIxOA;EACI,sBAAA;AJ2OJ;;AIxOA;EACI,uBAAA;EACA,WAAA;EACA,uCAAA;EACA,6DAAA;EACA,sCAAA;EACA,kBAAA;EACA,aAAA;AJ2OJ;;AIxOA;EACI,eAAA;EACA,aAAA;EAGA,iDAAA;EAEA,yCAAA;AJwOJ;;AIrOA;EACI,aAAA;EACA,wBAAA;EAGA,mDAAA;EAEA,yCAAA;EACA,kBAAA;EACA,SAAA;AJqOJ;AInOI;EACI,eAAA;EACA,YAAA;AJqOR;AIlOI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,6BAAA;EACA,YAAA;AJoOR;;AKhWA;EACI,aAAA;EACA,oCAAA;ALmWJ;AKjWI;EACI,oEAAA;ALmWR;AK/VI;EACI,cAAA;ALiWR;AK/VQ;EACI,iBAAA;ALiWZ;ACrWI;EITJ;IAkBQ,8EACI;EL+VV;AACF;ACpWI;EIfJ;IAuBQ,8EACI;EL+VV;AACF;ACnWI;EIrBJ;IA4BQ,+EACI;EL+VV;AACF;;AK5VA;EACI,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AL+VJ;AKzVI;EACI,UAAA;AL2VR;;AMvYA;;;EAGI,sBAAA;EACA,SAAA;EACA,UAAA;EACA,gDAAA;AN0YJ;;AMvYA;EACI,YAAA;AN0YJ;;AMvYA;;EAEI,eAAA;AN0YJ;;AMvYA;;;EAGI,YAAA;AN0YJ;;AMvYA;EACI,yCAAA;EACA,eAAA;EACA,uBAAA;AN0YJ;;AMtYA;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mCAAA;EACA,mBAAA;ANyYJ;AMvYI;EACI,YAAA;EACA,oBAAA;ANyYR;AMtYI;EACI,sCAAA;EACA,wBAAA;ANwYR;;AOzbA;EACI,yCAAA;AP4bJ;AO1bI;;EAEI,qBAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mCAAA;EACA,yCAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AP4bR;AOxbI;EACI,WAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,uBAAA;EACA,cAAA;EACA,2CAAA;EACA,yCAAA;EACA,kBAAA;AP0bR;AOxbQ;EACI,0CAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,YAAA;AP0bZ;AOvbQ;;EAEI,2CAAA;APybZ;AOrbQ;EACI,aAAA;APubZ;AOhbQ;EAEI,MAAA;EACA,sCAAA;EACA,wBAAA;EACA,yCAAA;EAYA,mDAAA;APsaZ;AOhbY;EACI,yCAAA;APkbhB;AOnaY;EACI,kDAAA;APqahB;AOlaY;EACI,mDAAA;APoahB;AOjaY;EACI,kBAAA;EACA,6CAAA;EACA,iBAAA;EACA,kBAAA;APmahB;AO/ZoB;EACI,WAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;APiaxB;AO/ZwB;EACI,qBAAA;APia5B;AOvZY;EACI,eAAA;EACA,mBAAA;EAEA,YAAA;EACA,kBAAA;EACA,YAAA;APwZhB;AOtZgB;EACI,iDAAA;APwZpB;AOlZgB;EACI,+CAAA;APoZpB;AO5YQ;EACI,sDAAA;EACA,qDAAA;AP8YZ;AO5YY;EACI,qDAAA;AP8YhB;AO1YY;EACI,sDAAA;AP4YhB;AOnYY;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;APqYhB;AOhYY;EACI,gBAAA;APkYhB;AOhYgB;EACI,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;APkYpB;AO/WQ;EACI,6BAAA;EACA,4BAAA;APiXZ;AO/WY;EACI,6BAAA;EACA,4BAAA;APiXhB;AO/WgB;EACI,4BAAA;APiXpB;AO7WgB;EACI,6BAAA;AP+WpB;AOvWI;EACI,WAAA;APyWR;AOvWQ;EACI,WAAA;EACA,kBAAA;APyWZ;AOtWQ;EACI,oBAAA;APwWZ;AOpWI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,qDAAA;EACA,sDAAA;EACA,kDAAA;EACA,iDAAA;EACA,gDAAA;APsWR;AOnWQ;EACI,2BAAA;EACA,iBAAA;APqWZ;AOjWQ;EACI,yCAAA;EACA,sCAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;APmWZ;AOjWY;EACI,wBAAA;EACA,qBAAA;APmWhB;;AQ/mBA;EACI,kBAAA;EACH,kBAAA;ARknBD;AQhnBI;EACI,YAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;EACA,yCAAA;EACA,oCAAA;EACA,mCAAA;EACA,6BAAA;EACA,eAAA;EACA,iCAAA;ARknBR;AQ9mBI;EACI,YAAA;EACA,6BAAA;EACA,6BAAA;ARgnBR;AQ9mBQ;EACI,oBAAA;EACA,YAAA;ARgnBZ;AQ3mBI;EACI,kBAAA;EACA,eAAA;EACA,OAAA;EACA,SAAA;EACA,6BAAA;EACA,0BAAA;EACA,mCAAA;EACA,yCAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;AR6mBR;AQ3mBQ;EACI,mBAAA;AR6mBZ;AQ1mBQ;EACI,gDAAA;AR4mBZ;AQzmBQ;EACI,gDAAA;AR2mBZ;AQxmBQ;EACI,2BAAA;AR0mBZ;AQxmBY;EACI,+BAAA;AR0mBhB;;AStqBA;EACI,uCAAA;EACA,sCAAA;EACA,qBAAA;EACA,8CAAA;EACA,mDAAA;EACA,qDAAA;ATyqBJ;;AStqBA;EACI,4BAAA;EACA,wCAAA;ATyqBJ;ASvqBI;EACI,wBAAA;EACA,gBAAA;EACA,eAAA;ATyqBR;;ASrqBA;EAgCI,WAAA;EACA,4BAAA;EACA,kBAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EAEA,MAAA;EACA,aAAA;EACA,mCAAA;ATwoBJ;AS9qBI;EACI,4BAAA;EACA,aAAA;ATgrBR;AS7qBI;EACI,aAAA;EACA,2BAAA;EACA,SAAA;AT+qBR;AS7qBQ;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mCAAA;EACA,mBAAA;EACA,sCAAA;EACA,wBAAA;EACA,qBAAA;AT+qBZ;AS7pBI;EACI,aAAA;EACA,WAAA;AT+pBR;AS7pBQ;EACI,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,4BAAA;EACA,UAAA;AT+pBZ;AS7pBY;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;AT+pBhB;AS5pBgB;EACI,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;AT8pBpB;AS5pBoB;EACI,kBAAA;EACA,uBAAA;EACA,wBAAA;AT8pBxB;AS1pBgB;EACI,kBAAA;EACA,8BAAA;EACA,wBAAA;EAGA,gBAAA;EACA,gCAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;EACA,4BAAA;AT0pBpB;AStpBoB;EACI,8CAAA;EACA,8BAAA;ATwpBxB;ASrpBoB;EACI,UAAA;EACA,4BAAA;ATupBxB;ASjpBgB;EACI,2DAAA;ATmpBpB;ASppBgB;EACI,2DAAA;ATspBpB;ASvpBgB;EACI,2DAAA;ATypBpB;ASnpBI;EACI,kBAAA;EACA,2BAAA;EACA,4BAAA;EACA,wCAAA;EACA,YAAA;EACA,kBAAA;EACA,yCAAA;EACA,gBAAA;ATqpBR;ASlpBQ;EAEI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;ATmpBZ;AS/oBQ;EACI,WAAA;EACA,gDAAA;EACA,gCAAA;ATipBZ;AS9oBQ;EACI,YAAA;EACA,iDAAA;EACA,+BAAA;ATgpBZ;;AS3oBA;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EAEA,YAAA;EACA,eAAA;AT6oBJ;;AUv0BA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,+BAAA;EAwBA,+BAAA;AVmzBF;AUz0BE;EACE,WAAA;EACA,6BAAA;EACA,2CAAA;EACA,yCAAA;EACA,aAAA;EACA,iCAAA;AV20BJ;AUr0BI;EAGE,MAAA;EACA,uBAAA;EACA,wBAAA;EACA,6BAAA;EACA,cAAA;AVq0BN;AUh0BE;EACD,uBAAA;EAAA,kBAAA;AVk0BD;AU/zBE;EACD,eAAA;EACG,gBAAA;EACH,iBAAA;EACG,2CAAA;EACA,yCAAA;EACA,aAAA;EACA,iCAAA;AVi0BJ;AU3zBI;EAGE,MAAA;EACA,uBAAA;EACA,wBAAA;EACA,6BAAA;EACA,cAAA;AV2zBN;AUvzBE;EACD,eAAA;AVyzBD;AUtzBE;EACD,YAAA;AVwzBD;AUrzBE;EACE,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,iBAAA;EACA,YAAA;EACA,iCAAA;EACA,iCAAA;EAEA,uBAAA;EACA,UAAA;AVszBJ;;AWn4BA;EACI,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AXs4BJ;AWp4BI;EACI,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,sCAAA;EACA,kBAAA;EACA,8DAAA;EACA,sEAAA;AXs4BR;AWp4BQ;EACI,uBAAA;AXs4BZ;AWn4BQ;EACI,sBAAA;AXq4BZ;AWl4BQ;EACI,uBAAA;AXo4BZ;;AWn3BA;EACI;IACI,uBAAA;EXs3BN;EWn3BE;IACI,yBAAA;EXq3BN;AACF;AYz6BA;EACI,kBAAA;EACA,wCAAA;EACA,sBAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AZ26BJ;AYz6BI;EACI,YAAA;EACA,qBAAA;AZ26BR;;Aav7BA;EACI,6CAAA;EAEA,kBAAA;Aby7BJ;;Ac37BI;EACI,UAAA;EACA,kBAAA;EACA,mBAAA;Ad87BR;Ac57BQ;EACI,YAAA;Ad87BZ;Ac17BQ;EACI,mCAAA;Ad47BZ;Acz7BQ;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;Ad27BZ;Acz7BY;EAEI,WAAA;EACA,oBAAA;EACA,iCAAA;Ad07BhB;Acv7BY;EACI,UAAA;EACA,WAAA;EACA,sCAAA;EACA,yBAAA;Ady7BhB;Act7BY;EACI,YAAA;EACA,aAAA;EACA,WAAA;EACA,wCAAA;EACA,kBAAA;Adw7BhB;Acl7BY;EACI,wCAAA;Ado7BhB;Acj7BY;EACI,sCAAA;EACA,2BAAA;Adm7BhB;;Aev+BA;EACC,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,6BAAA;EACA,eAAA;EACA,UAAA;EAEA,6BAAA;EACA,kBAAA;EACA,qBAAA;EACA,wBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kCAAA;Afy+BD;Aet+BC;EACC,eAAA;Afw+BF;Aer+BC;EACC,WAAA;EACA,kBAAA;EACA,2CAAA;EACA,UAAA;Afu+BF;Aen+BC;EAEC,yCAAA;EAEA,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;Afm+BF;Aeh+BC;EACC,SAAA;EACA,+CAAA;Afk+BF;Ae/9BC;EACC,QAAA;EACA,8BAAA;Afi+BF;Ae99BC;EACC,OAAA;EACA,8BAAA;Afg+BF;Ae59BE;EACC,wFAAA;EAEA,SAAA;EACA,gCAAA;Af69BH;Ae19BE;EAEC,sDAAA;Af29BH;Aet9BE;EACC,yFAAA;EAEA,MAAA;EACA,6BAAA;Afu9BH;Aep9BE;EAEC,yDAAA;Afq9BH;Aej9BC;EAEC,UAAA;Afk9BF;;AgB9iCA;EACI,kBAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,yCAAA;EACA,aAAA;EACA,0CAAA;AhBijCJ;AgB/iCI;EACI,kCAAA;AhBijCR;AgB9iCI;EACI,YAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;AhBgjCR;AgB7iCI;;EAEI,YAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;AhB+iCR;AgB5iCI;EACI,YAAA;EACA,kBAAA;EACA,uEAAA;EACA,WAAA;AhB8iCR;AgB5iCQ;EACI,wCAAA;EACA,6BAAA;EACA,wBAAA;EACA,UAAA;AhB8iCZ;AgBziCI;EACI,gBAAA;EACA,wBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;AhB2iCR;AgBziCQ;EAEI,yBAAA;AhB0iCZ;AgBtiCI;EACI,mCAAA;EACA,mBAAA;EACA,aAAA;AhBwiCR;AgBriCI;EACI,gBAAA;EACA,gCAAA;EACA,mCAAA;AhBuiCR;AgBpiCI;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,sCAAA;EACA,qBAAA;EACA,WAAA;EACA,OAAA;EACA,wBAAA;EACA,uBAAA;EACA,YAAA;AhBsiCR;AgBpiCQ;EACI,cAAA;AhBsiCZ;AgBniCQ;EACI,qBAAA;EACA,eAAA;AhBqiCZ;AgBniCY;EACI,qCAAA;AhBqiChB;AgBliCY;EACI,qCAAA;EACA,YAAA;AhBoiChB;AgB/hCI;EACI,aAAA;EACA,mBAAA;EACA,sCAAA;EACA,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AhBiiCR;AgB/hCQ;EACI,iBAAA;EACA,wBAAA;AhBiiCZ;AgB9hCQ;EAEI,mCAAA;EACA,+BAAA;AhB+hCZ;AgB7hCY;EACI,wBAAA;AhB+hChB;;AiBrqCA;EACI,kBAAA;EACA,kBAAA;AjBwqCJ;AiBtqCI;EACI,YAAA;EACA,uBAAA;EACA,aAAA;EACA,mCAAA;EACA,yCAAA;AjBwqCR;AiBtqCQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AjBwqCZ;AiBnqCI;EACI,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mCAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,yCAAA;EACA,mBAAA;EACA,6EAAA;EACA,0BAAA;AjBqqCR;AiBnqCQ;EACI,mBAAA;AjBqqCZ;AiBlqCQ;EACI,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;EACA,0BAAA;AjBoqCZ;AiBlqCY;EACI,oCAAA;AjBoqChB;;AkBztCA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EAEA,kBAAA;EACA,wBAAA;EACA,qBAAA;AlB2tCJ;AkBxtCI;EACI,eAAA;EACA,aAAA;AlB0tCR;AkBxtCQ;EACI,WAAA;EACA,UAAA;EACA,WAAA;EACA,yCAAA;EACA,mBAAA;EACA,sCAAA;AlB0tCZ;AkBttCI;;EAEI,sCAAA;EACA,sCAAA;AlBwtCR;AkBrtCI;EACI,eAAA;EACA,UAAA;EACA,kBAAA;AlButCR;AkBrtCQ;EACI,mCAAA;AlButCZ;AkBptCQ;EAEI,wBAAA;EACA,eAAA;AlBqtCZ;AkBntCY;EACI,sCAAA;EACA,kBAAA;AlBqtChB;AkB/sCY;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,6CAAA;EACA,2CAAA;EACA,6CAAA;EACA,yCAAA;AlBitChB;AkB7sCY;EACI,sCAAA;EACA,sCAAA;AlB+sChB;;AmBlxCA;EACI,eAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;AnBoxCJ;AmBlxCI;EACI,iBAAA;EACA,aAAA;EACA,YAAA;EACA,yCAAA;EACA,YAAA;EACA,kCAAA;EACA,aAAA;EACA,SAAA;EACA,uBAAA;AnBoxCR;AmBlxCQ;EACI,YAAA;EACA,eAAA;EACA,eAAA;AnBoxCZ;AmBjxCQ;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;AnBmxCZ;AmBjxCY;EACI,wBAAA;EACA,iBAAA;AnBmxChB;AmB/wCQ;EACI,8BAAA;AnBixCZ;AmB9wCQ;EACI,gCAAA;AnBgxCZ;AmB7wCQ;EACI,gCAAA;AnB+wCZ;AmB5wCQ;EACI,6BAAA;AnB8wCZ;;AoBr0CA;EAEI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mCAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,uCAAA;EACA,oBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;ApBu0CJ;AoBn0CI;EACI,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,6BAAA;EACA,cAAA;ApBq0CR;;AoBj0CA;EACI;IACI,QAAA;EpBo0CN;EoBj0CE;IACI,QAAA;EpBm0CN;AACF;AqB52CA;EACI,aAAA;EACA,sBAAA;EACA,QAAA;ArB82CJ;AqB52CI;EACI,kBAAA;EACA,uBAAA;EAEA,uCAAA;ArB62CR;AqB12CY;EACI,yBAAA;ArB42ChB;AqBz2CY;EACI,kBAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;ArB22ChB;AqBv2CQ;EACI,wBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;ArBy2CZ;AqBv2CY;EACI,uCAAA;ArBy2ChB;AqBr2CQ;EACI,oBAAA;EACA,aAAA;EACA,iCAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;ArBu2CZ;;AsBn5CA;EACC,mBAAA;AtBs5CD;;AsBn5CA;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AtBs5CF;;AsBn5CA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,uCAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EAEA,gBAAA;EACA,aAAA;AtBq5CF;AsBn5CE;EACE,aAAA;AtBq5CJ;;AsBj5CA;EACE,UAAA;EACA,uBAAA;AtBo5CF;;AsBj5CA;EACE,UAAA;AtBo5CF;;AsBj5CA;EACE,YAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,mCAAA;AtBo5CF;;AsBj5CA;EACE,wBAAA;AtBo5CF;;AsBj5CA;EACE,6BAAA;AtBo5CF;;AsBj5CA;;EAEE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AtBo5CF;AsBl5CE;;EACE,eAAA;EACA,eAAA;EACA,2BAAA;AtBq5CJ;AsBl5CE;;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AtBq5CJ;;AsBh5CA;EACE,SAAA;AtBm5CF;;AsBh5CA;EACE,aAAA;EACA,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AtBm5CF;AsBj5CE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AtBm5CJ;;AuBj/CI;EACI,cAAA;EACA,oBAAA;EACA,gBAAA;AvBo/CR;AuBh/CI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yCAAA;AvBk/CR;AuB/+CQ;EACI,YAAA;EACA,aAAA;EACA,yCAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,iCAAA;AvBi/CZ;AuB9+CQ;EACI,uBAAA;AvBg/CZ;AuB9+CY;EACI,UAAA;AvBg/ChB;AuBz+CI;EACI,uBAAA;EACA,aAAA;EACA,gBAAA;AvB2+CR;AuBz+CQ;EACI,qBAAA;AvB2+CZ;AuBv+CI;EACI,aAAA;EACA,SAAA;EACA,gDAAA;AvBy+CR;;AwB5hDA;EACI,eAAA;AxB+hDJ;AwB7hDI;EACI,gBAAA;AxB+hDR;AwB5hDI;EACI,kBAAA;AxB8hDR;;AwB1hDA;EACI,6CAAA;AxB6hDJ;;AyBziDI;EACI,kBAAA;AzB4iDR;AyBziDI;EAEI,aAAA;EACA,mCAAA;EACA,SAAA;EACA,mBAAA;AzB0iDR;AyBxiDQ;EACI,eAAA;AzB0iDZ;AyBviDQ;EACI,gBAAA;AzByiDZ;AyBriDQ;EACI,gBAAA;AzBuiDZ;AyBjiDI;EACI,aAAA;EACA,sCAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;AzBmiDR;AyBjiDE;EACC,sBAAA;EACA,WAAA;AzBmiDH;AyBhiDQ;EACI,kBAAA;EACA,UAAA;EACA,mCAAA;EACA,aAAA;EACA,uCAAA;EAEA,iBAAA;AzBiiDZ;AyB7hDY;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,0BAAA;AzB+hDhB;AyB7hDgB;EACI,mBAAA;AzB+hDpB;AyB3hDY;EACI,cAAA;EACA,gBAAA;EACA,2BAAA;AzB6hDhB;AyB3hDgB;EACI,iBAAA;AzB6hDpB;AyBvhDY;EACI,sCAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,uCAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AzByhDhB;AyBthDY;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iCAAA;AzBwhDhB;AyBthDgB;EACI,eAAA;AzBwhDpB;AyBphDY;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AzBshDhB;AyBphDgB;EAEI,kBAAA;EACA,kBAAA;AzBqhDpB;AyBnhDoB;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,kCAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;AzBqhDxB;AyB/gDY;EACI,kBAAA;AzBihDhB;AyB/gDgB;EACI,6BAAA;EACA,6BAAA;EACA,oBAAA;AzBihDpB;AyB9gDgB;EACI,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,sCAAA;EACA,gDAAA;EACA,iDAAA;EACA,YAAA;AzBghDpB;AyB5gDY;EACI,kBAAA;AzB8gDhB;AyB3gDgB;EACI,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,wCAAA;EACA,gDAAA;EACA,iDAAA;EACA,YAAA;AzB6gDpB;AyBzgDY;EACI,kBAAA;AzB2gDhB;AyBxgDgB;EACI,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,wCAAA;EACA,gDAAA;EACA,iDAAA;EACA,QAAA;EACf,sCAAA;AzB0gDL;;A0B5sDC;EACC,aAAA;EACA,kCAAA;EACA,SAAA;A1B+sDF;A0B7sDE;EACC,aAAA;EACA,uCAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,mCAAA;A1B+sDH;A0B7sDG;EACC,gBAAA;A1B+sDJ;A0B3sDC;EAGC,WAAA;A1B2sDF;A0BzsDE;EACC,gBAAA;EACA,iBAAA;A1B2sDH;A0BxsDE;EACC,aAAA;EACA,kBAAA;EACA,gBAAA;A1B0sDH;A0BvsDI;EACC,0BAAA;A1BysDL;A0BtsDI;EACC,uCAAA;EACA,0BAAA;A1BwsDL;A0BjsDG;EAUC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,QAAA;EACA,uCAAA;A1B0rDJ;A0BrrDC;EACC,kBAAA;EACA,wCAAA;EACA,wBAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,YAAA;EACA,UAAA;EACA,6CAAA;EACA,sBAAA;EACA,uBAAA;EACA,yCAAA;EACA,aAAA;A1BurDF;A0BrrDE;EACC,aAAA;A1BurDH;A0BprDE;EACC,WAAA;EACA,kBAAA;EACA,aAAA;EAGA,6BAAA;EACA,wCAAA;EAEA,qBAAA;A1BmrDH;A0BvqDC;EACC,aAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;A1ByqDF;A0BtqDC;EACC,0BAAA;EACA,kBAAA;A1BwqDF;A0BrqDG;EACC,UAAA;A1BuqDJ;;A2BlyDI;EACI,aAAA;EACA,kCAAA;EACA,SAAA;A3BqyDR;A2BnyDQ;EACI,aAAA;EACA,uCAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,mCAAA;A3BqyDZ;A2BnyDY;EACI,gBAAA;A3BqyDhB;A2BhyDI;EACI,qBAAA;EACA,YAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mCAAA;EACA,yCAAA;EACA,SAAA;EACA,kBAAA;A3BkyDR;;AAjyDA;EACE,eAAA;AAoyDF;AAlyDE;EACE,mBAAA;AAoyDJ;AAlyDI;EACE,SAAA;AAoyDN;AAjyDI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,2BAAA;AAmyDN;AAhyDI;EACE,UAAA;EACA,mBAAA;AAkyDN;AA/xDI;EACE,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAiyDN;;AA5xDA;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mCAAA;EACA,mBAAA;EACA,sCAAA;EACA,wBAAA;EACA,qBAAA;AA+xDF;;AA5xDA;;EAEE,eAAA;EACA,qBAAA;AA+xDF","sourcesContent":[":root {\n    // Colors\n    --background-color: white;\n    --background-table-header: white;\n    --text-table-header: white;\n    --table-border-color: white;\n    --color-primary: white;\n    --color-secondary: white;\n    --text-dark: white;\n    --text-dark-secondary: white;\n    --text-light: white;\n    --small-border-radius: 4px;\n    --big-border-radius: 4px;\n    --light-box-shadow: 0px 0px 3px 0 #23394230;\n}\n\n\n// Breakpoints\n$mobile-breakpoint: 460px;\n$narrow-breakpoint: 720px;\n$normal-breakpoint: 1200px;","// Setup\n@import \"setup/variables.scss\";\n@import \"setup/functions.scss\";\n@import \"setup/mixins.scss\";\n@import \"setup/animations.scss\";\n@import \"setup/typography.scss\";\n\n// Basics\n@import \"basics/helpers.scss\";\n@import \"basics/layout.scss\";\n@import \"basics/base.scss\";\n\n// Components\n@import \"components/table.scss\";\n@import \"components/date-picker-container.scss\";\n@import \"components/navbar.scss\";\n@import \"components/input.scss\";\n@import \"components/loader.scss\";\n@import \"components/footer.scss\";\n@import \"components/loader-page.scss\";\n@import \"components/switch.scss\";\n@import \"components/tooltip.scss\";\n@import \"components/select.scss\";\n@import \"components/dropdown.scss\";\n@import \"components/checkbox.scss\";\n@import \"components/notifications.scss\";\n@import \"components/context-menu.scss\";\n@import \"components/accordion.scss\";\n@import \"components/modal.scss\";\n\n//pages\n@import \"pages/dashboard.scss\";\n@import \"pages/no-shop.scss\";\n@import \"pages/plans.scss\";\n@import \"pages/home.scss\";\n@import \"pages/orders.scss\";\n\n.instructions {\n  font-size: 24px;\n\n  .oversight-container {\n    padding: 12px 100px;\n\n    .list-and-image {\n      gap: 50px;\n    }\n\n    .title {\n      font-size: 60px;\n      font-weight: 600;\n      text-align: center;\n      padding-bottom: 50px;\n      color: var(--color-primary);\n    }\n\n    img {\n      width: 30%;\n      object-fit: contain;\n    }\n\n    ol {\n      padding-inline-start: 25px;\n      display: flex;\n      flex-direction: column;\n      gap: 30px;\n      font-weight: 300;\n    }\n  }\n}\n\n.button {\n  border: none;\n  padding: 4px 10px;\n  font-size: 12px;\n  border-radius: var(--small-border-radius);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  box-shadow: var(--light-box-shadow);\n  white-space: nowrap;\n  background-color: var(--color-primary);\n  color: var(--text-light);\n  text-decoration: none;\n}\n\nbutton,\na {\n  cursor: pointer;\n  text-decoration: none;\n}\n","/* Breakpoint mixins */\n\n@mixin for-mobile-layout {\n    @media (max-width: $mobile-breakpoint + 40) {\n        @content;\n    }\n}\n\n@mixin for-narrow-layout {\n    @media (min-width: $mobile-breakpoint + 40) {\n        @content;\n    }\n}\n\n@mixin for-normal-layout {\n    @media (min-width: $narrow-breakpoint + 40) {\n        @content;\n    }\n}\n\n@mixin for-wide-layout {\n    @media (min-width: $normal-breakpoint + 40) {\n        @content;\n    }\n}","@keyframes flip {\n    0% {\n        margin-top: -360px;\n    }\n\n    5% {\n        margin-top: -270px;\n    }\n\n    25% {\n        margin-top: -270px;\n    }\n\n    30% {\n        margin-top: -180px;\n    }\n\n    50% {\n        margin-top: -180px;\n    }\n\n    55% {\n        margin-top: -90px;\n    }\n\n    75% {\n        margin-top: -90px;\n    }\n\n    80% {\n        margin-top: 0px;\n    }\n\n    99.99% {\n        margin-top: 0px;\n    }\n\n    100% {\n        margin-top: -360px;\n    }\n}","@font-face {\n    font-family: assistant;\n    src: url(../../fonts/Assistant/Assistant-ExtraLight.ttf);\n    font-weight: 100;\n  }\n  @font-face {\n    font-family: assistant;\n    src: url(../../fonts/Assistant/Assistant-ExtraLight.ttf);\n    font-weight: 200;\n  }\n  @font-face {\n    font-family: assistant;\n    src: url(../../fonts/Assistant/Assistant-Light.ttf);\n    font-weight: 300;\n  }\n  @font-face {\n    font-family: assistant;\n    src: url(../../fonts/Assistant/Assistant-Regular.ttf);\n    font-weight: 400;\n  }\n  @font-face {\n    font-family: assistant;\n    src: url(../../fonts/Assistant/Assistant-Medium.ttf);\n    font-weight: 500;\n  }\n  @font-face {\n    font-family: assistant;\n    src: url(../../fonts/Assistant/Assistant-SemiBold.ttf);\n    font-weight: 600;\n  }\n  @font-face {\n    font-family: assistant;\n    src: url(../../fonts/Assistant/Assistant-Bold.ttf);\n    font-weight: 700;\n  }\n  @font-face {\n    font-family: assistant;\n    src: url(../../fonts/Assistant/Assistant-ExtraBold.ttf);\n    font-weight: 800;\n  }\n\n  @font-face {\n    font-family: open-sans;\n    src: url(../../fonts/OpenSans/OpenSans_Condensed-Light.ttf);\n    font-weight: 100;\n  }\n  @font-face {\n    font-family: open-sans;\n    src: url(../../fonts/OpenSans/OpenSans_Condensed-Light.ttf);\n    font-weight: 200;\n  }\n  @font-face {\n    font-family: open-sans;\n    src: url(../../fonts/OpenSans/OpenSans_Condensed-Regular.ttf);\n    font-weight: 300;\n  }\n  @font-face {\n    font-family: open-sans;\n    src: url(../../fonts/OpenSans/OpenSans_Condensed-Regular.ttf);\n    font-weight: 400;\n  }\n  @font-face {\n    font-family: open-sans;\n    src: url(../../fonts/OpenSans/OpenSans_Condensed-Medium.ttf);\n    font-weight: 500;\n  }\n  @font-face {\n    src: url(../../fonts/OpenSans/OpenSans_Condensed-SemiBold.ttf);\n    font-family: open-sans;\n    font-weight: 600;\n  }\n  @font-face {\n    font-family: open-sans;\n    src: url(../../fonts/OpenSans/OpenSans_Condensed-Bold.ttf);\n    font-weight: 700;\n  }\n  @font-face {\n    font-family: open-sans;\n    src: url(../../fonts/OpenSans/OpenSans_Condensed-ExtraBold.ttf);\n    font-weight: 800;\n  }\n\n  @font-face {\n    font-family: open-sans2;\n    src: url(../../fonts/OpenSans2/OpenSans-Light.ttf);\n    font-weight: 100;\n  }\n  @font-face {\n    font-family: open-sans2;\n    src: url(../../fonts/OpenSans2/OpenSans-Light.ttf);\n    font-weight: 200;\n  }\n  @font-face {\n    font-family: open-sans2;\n    src: url(../../fonts/OpenSans2/OpenSans-Regular.ttf);\n    font-weight: 300;\n  }\n  @font-face {\n    font-family: open-sans2;\n    src: url(../../fonts/OpenSans2/OpenSans-Regular.ttf);\n    font-weight: 400;\n  }\n  @font-face {\n    font-family: open-sans2;\n    src: url(../../fonts/OpenSans2/OpenSans-Medium.ttf);\n    font-weight: 500;\n  }\n  @font-face {\n    src: url(../../fonts/OpenSans2/OpenSans-SemiBold.ttf);\n    font-family: open-sans2;\n    font-weight: 600;\n  }\n  @font-face {\n    font-family: open-sans2;\n    src: url(../../fonts/OpenSans2/OpenSans-Bold.ttf);\n    font-weight: 700;\n  }\n  @font-face {\n    font-family: open-sans2;\n    src: url(../../fonts/OpenSans2/OpenSans-ExtraBold.ttf);\n    font-weight: 800;\n  }\n  \n  @font-face {\n    font-family: heebo;\n    src: url(../../fonts/Heebo/Heebo-Black.ttf);\n    font-weight: 800;\n  }\n\n  \n  @font-face {\n    font-family: heebo;\n    src: url(../../fonts/Heebo/Heebo-ExtraLight.ttf);\n    font-weight: 100;\n  }\n  @font-face {\n    font-family: heebo;\n    src: url(../../fonts/Heebo/Heebo-Light.ttf);\n    font-weight: 200;\n  }\n  @font-face {\n    font-family: heebo;\n    src: url(../../fonts/Heebo/Heebo-Regular.ttf);\n    font-weight: 300;\n  }\n  @font-face {\n    font-family: heebo;\n    src: url(../../fonts/Heebo/Heebo-Medium.ttf);\n    font-weight: 400;\n  }\n  @font-face {\n    font-family: heebo;\n    src: url(../../fonts/Heebo/Heebo-SemiBold.ttf);\n    font-weight: 500;\n  }\n  @font-face {\n    font-family: heebo;\n    src: url(../../fonts/Heebo/Heebo-Bold.ttf);\n    font-weight: 600;\n  }\n  @font-face {\n    font-family: heebo;\n    src: url(../../fonts/Heebo/Heebo-ExtraBold.ttf);\n    font-weight: 700;\n  }\n  @font-face {\n    font-family: heebo;\n    src: url(../../fonts/Heebo/Heebo-Black.ttf);\n    font-weight: 800;\n  }\n\n    \n  @font-face {\n    font-family: almoni;\n    src: url(../../fonts/almoni/ALMONI-TZAR-AAA-LIGHT.OTF);\n    font-weight: 100;\n  }\n  @font-face {\n    font-family: almoni;\n    src: url(../../fonts/almoni/ALMONI-TZAR-AAA-LIGHT.OTF);\n    font-weight: 200;\n  }\n  @font-face {\n    font-family: almoni;\n    src: url(../../fonts/almoni/ALMONI-TZAR-AAA-LIGHT.OTF);\n    font-weight: 300;\n  }\n  @font-face {\n    font-family: almoni;\n    src: url(../../fonts/almoni/ALMONI-TZAR-AAA-REGULAR.OTF);\n    font-weight: 400;\n  }\n  @font-face {\n    font-family: almoni;\n    src: url(../../fonts/almoni/ALMONI-TZAR-AAA-REGULAR.OTF);\n    font-weight: 500;\n  }\n  @font-face {\n    font-family: almoni;\n    src: url(../../fonts/almoni/ALMONI-TZAR-AAA-BOLD.OTF);\n    font-weight: 600;\n  }\n  @font-face {\n    font-family: almoni;\n    src: url(../../fonts/almoni/ALMONI-TZAR-AAA-BOLD.OTF);\n    font-weight: 700;\n  }\n  @font-face {\n    font-family: almoni;\n    src: url(../../fonts/almoni/ALMONI-TZAR-AAA-BOLD.OTF);\n    font-weight: 800;\n  }",".flex {\n    display: flex;\n\n    &.column {\n        flex-direction: column;\n    }\n\n    &.row {\n        flex-direction: row;\n    }\n\n    &.justify-center {\n        justify-content: center;\n    }\n\n    &.justify-start {\n        justify-content: flex-start;\n    }\n\n    &.justify-space-between {\n        justify-content: space-between;\n    }\n\n    &.justify-space-around {\n        justify-content: space-around;\n    }\n\n    &.justify-end {\n        justify-content: flex-end;\n    }\n\n    &.align-center {\n        align-items: center;\n    }\n\n    &.align-start {\n        align-items: flex-start;\n    }\n\n    &.align-end {\n        align-items: flex-end;\n    }\n\n    &.gap-1 {\n        gap: 1rem;\n    }\n\n    &.gap-0-5 {\n        gap: 0.5rem;\n    }\n\n    &.gap-small {\n        gap: 4px;\n    }\n\n    .full {\n        flex-grow: 1;\n    }\n}\n\n.flex-center {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n\n.w100 {\n    width: 100%;\n}\n\n.h100 {\n    height: 100%;\n}\n\n// Media helpers\n\n\n\n.site-block {\n    margin-bottom: rem(20px);\n}\n\n.oversight-container {\n    background-color: white;\n    width: 100%;\n    border-radius: var(--big-border-radius);\n    transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n    box-shadow: #e0e0e0 0px 0.5rem 1.25rem;\n    position: relative;\n    padding: 12px;\n}\n\n.limit-plan {\n    margin-top: 5px;\n    padding: 20px;\n    // border: 1px solid #FFCC00;\n    // background-color: white;\n    background-color: #ffcc0032;\n    // color: var(--text-light);\n    border-radius: var(--small-border-radius);\n}\n\n.explan {\n    padding: 20px;\n    padding-inline-end: 30px;\n    // border: 1px solid #FFCC00;\n    // background-color: white;\n    background-color: #a9d9f032;\n    // color: var(--text-light);\n    border-radius: var(--small-border-radius);\n    position: relative;\n    gap: 30px;\n\n    svg {\n        font-size: 40px;\n        opacity: 0.5;\n    }\n\n    .close {\n        position: absolute;\n        right: 10px;\n        top: 10px;\n        background-color: transparent;\n        border: none;\n    }\n}",".main-container {\n    display: grid;\n    grid-template-columns: 20px 1fr 20px;\n\n    &:has(> .page) {\n        min-height: calc(100% - var(--footer-height) - var(--navbar-height));\n    }\n\n\n    >* {\n        grid-column: 2;\n\n        &.full {\n            grid-column: 1 /-1;\n        }\n    }\n\n    @include for-narrow-layout {\n        grid-template-columns:\n            minmax(20px, 1fr) minmax(auto, $mobile-breakpoint) minmax(20px, 1fr);\n    }\n\n    @include for-normal-layout {\n        grid-template-columns:\n            minmax(20px, 1fr) minmax(auto, $narrow-breakpoint) minmax(20px, 1fr);\n    }\n\n    @include for-wide-layout {\n        grid-template-columns:\n            minmax(20px, 1fr) minmax(auto, $normal-breakpoint) minmax(20px, 1fr);\n    }\n}\n\n.page {\n    height: 100%;\n    padding-top: 40px;\n    padding-bottom: 40px;\n    position: relative;\n\n    // .date-picker-with-button {\n    //     position: absolute;\n    //     top: 20px;\n    // }\n    .error {\n        color: red;\n    }\n}","*,\n*::after,\n*::before {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n    font-family: heebo, Arial, Helvetica, sans-serif;\n}\n\nhtml {\n    height: 100%;\n}\n\nbutton,\na {\n    cursor: pointer;\n}\n\nbody,\n#root,\n.App {\n    height: 100%;\n}\n\nbody {\n    background-color: var(--background-color);\n    font-size: 16px;\n    color: var(--text-dark);\n}\n\n\n.button {\n    border: none;\n    padding: 4px 10px;\n    font-size: 12px;\n    border-radius: var(--small-border-radius);\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    box-shadow: var(--light-box-shadow);\n    white-space: nowrap;\n\n    &:disabled {\n        opacity: 0.5;\n        pointer-events: none;\n    }\n\n    &.primary {\n        background-color: var(--color-primary);\n        color: var(--text-light);\n    }\n}",".table-container {\n    border-radius: var(--small-border-radius);\n\n    button,\n    a {\n        text-decoration: none;\n        color: black;\n        background-color: white;\n        border: none;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 10px;\n        box-shadow: var(--light-box-shadow);\n        border-radius: var(--small-border-radius);\n        margin-inline: auto;\n        gap: 10px;\n        width: max-content;\n\n    }\n\n    table.table {\n        width: 100%;\n        max-width: 100%;\n        border-spacing: 0;\n        border-collapse: none;\n        background-color: white;\n        display: table;\n        border: 1px solid var(--table-border-color);\n        border-radius: var(--small-border-radius);\n        position: relative;\n\n        .resizer {\n            /* Displayed at the right side of column */\n            position: absolute;\n            top: 0;\n            right: 0;\n            width: 5px;\n            cursor: col-resize;\n            user-select: none;\n            z-index: 999;\n        }\n\n        .resizer:hover,\n        .resizing {\n            border-right: 2px solid var(--navbar-color);\n\n        }\n\n        .hide {\n            display: none;\n        }\n\n\n\n\n\n        thead {\n            // position: sticky;\n            top: 0;\n            background-color: var(--color-primary);\n            color: var(--text-light);\n            border-radius: var(--small-border-radius);\n\n            tr {\n                border-radius: var(--small-border-radius);\n\n            }\n\n            // th {\n            //     width: calc(100% / 6);\n\n            // }\n\n            /* Don't forget this, required for the stickiness */\n            // color: white;\n            // background-color: #9EA7AA;\n            // background-color: #BABDBE;\n\n\n            th:first-child {\n                border-top-left-radius: var(--small-border-radius);\n            }\n\n            th:last-child {\n                border-top-right-radius: var(--small-border-radius);\n            }\n\n            th {\n                text-align: center;\n                border-bottom: 1px solid var(--border-bottom);\n                padding: 20px 8px;\n                position: relative;\n\n\n                .arrow-button-container {\n                    button {\n                        width: 20px;\n                        height: 11px;\n                        background-color: transparent;\n                        border: none;\n                        color: white;\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n\n                        &.curr {\n                            transform: scale(1.2);\n                        }\n                    }\n                }\n            }\n        }\n\n\n\n        tr {\n            td {\n                padding: 0 16px;\n                display: table-cell;\n                // text-transform: capitalize;\n                height: 60px;\n                text-align: center;\n                padding: 8px;\n\n                &:not(:last-child) {\n                    border-right: 1px solid var(--table-border-color);\n                }\n\n            }\n\n            &:not(:first-child) {\n                td {\n                    border-top: 1px solid var(--table-border-color);\n\n                }\n            }\n        }\n\n\n\n        tr:last-child {\n            border-bottom-right-radius: var(--small-border-radius);\n            border-bottom-left-radius: var(--small-border-radius);\n\n            td:first-child {\n                border-bottom-left-radius: var(--small-border-radius);\n\n            }\n\n            td:last-child {\n                border-bottom-right-radius: var(--small-border-radius);\n            }\n        }\n\n        .options {\n            // display: flex;\n            // gap: 1rem;\n            // align-items: center;\n\n            button {\n                display: inline-flex;\n                align-items: center;\n                justify-content: center;\n                margin: 0 5px 0 0;\n                aspect-ratio: 1/1;\n                width: 35px;\n                font-size: 15px;\n            }\n        }\n\n        tbody {\n            td {\n                max-width: 100px;\n\n                .three-dots {\n                    display: block;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    white-space: nowrap;\n\n\n                }\n            }\n\n            tr:nth-child(2n) {\n                // background-color: var(--background);\n            }\n        }\n\n        .loader {\n            // width: 50px;\n            // height: 50px;\n        }\n\n    }\n\n    &:has(.paginator) {\n        table.table {\n            border-bottom-right-radius: 0;\n            border-bottom-left-radius: 0;\n\n            tr:last-child {\n                border-bottom-right-radius: 0;\n                border-bottom-left-radius: 0;\n\n                td:first-child {\n                    border-bottom-left-radius: 0;\n\n                }\n\n                td:last-child {\n                    border-bottom-right-radius: 0;\n                }\n            }\n        }\n    }\n\n\n\n    .table-checkbox {\n        width: 30px;\n\n        .checkbox-container {\n            width: 30px;\n            text-align: center;\n        }\n\n        label:before {\n            margin: 0 !important;\n        }\n    }\n\n    .paginator {\n        display: flex;\n        align-items: center;\n        gap: 1rem;\n        padding: 1rem;\n        background-color: white;\n        border-bottom-left-radius: var(--small-border-radius);\n        border-bottom-right-radius: var(--small-border-radius);\n        border-bottom: 1px solid var(--table-border-color);\n        border-right: 1px solid var(--table-border-color);\n        border-left: 1px solid var(--table-border-color);\n\n\n        span {\n            color: var(--color-primary);\n            font-weight: bold;\n        }\n\n\n        .page {\n            border-radius: var(--small-border-radius);\n            background-color: var(--color-primary);\n            padding: 5px;\n            width: 35px;\n            height: 35px;\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            color: white;\n            margin: 0;\n            cursor: pointer;\n\n            &.curr {\n                font-weight: var(--bold);\n                transform: scale(1.2);\n            }\n        }\n    }\n}",".date-picker-container {\n    position: relative;\n\twidth: max-content;\n\n    .range-picker-toggle {\n        height: 33px;\n        display: flex;\n        gap: 10px;\n        align-items: center;\n        border: none;\n        border-radius: var(--small-border-radius);\n        background-color: rgb(255, 255, 255);\n        box-shadow: var(--light-box-shadow);\n        border: 1px solid transparent;\n        padding: 0 10px;\n        color: var(--text-dark-secondary);\n\n    }\n\n    .refresh-button {\n        border: none;\n        background-color: transparent;\n        color: var(--color-secondary);\n\n        &:disabled {\n            pointer-events: none;\n            opacity: 0.3;\n        }\n    }\n\n\n    .range-picker {\n        position: absolute;\n        z-index: 999999;\n        left: 0;\n        bottom: 0;\n        transition: 300ms ease-in-out;\n        transform-origin: left top;\n        box-shadow: var(--light-box-shadow);\n        border-radius: var(--small-border-radius);\n        overflow: hidden;\n        background-color: white;\n        padding-block-end: 10px;\n\n        .save-dates {\n            margin-inline: 10px;\n        }\n\n        &.close {\n            transform: translateY(calc(100% + 5px)) scale(0);\n        }\n\n        &.open {\n            transform: translateY(calc(100% + 5px)) scale(1);\n        }\n\n        .rdrDayNumber {\n            transform: translatey(-5px);\n\n            span:after {\n                transform: translate(-50%, 6px);\n            }\n\n            // color: var(--color-primary) !important;\n        }\n    }\n}",":root {\n    --indicator-color: var(--color-primary);\n    --navbar-color: var(--color-secondary);\n    --navbar-height: 80px;\n    --svg-width: calc(var(--navbar-height) * 0.34);\n    --text-font-size: calc(var(--navbar-height) * 0.17);\n    --icon-translate-y: calc(var(--navbar-height) * 0.48);\n}\n\n.navbar-wrapper {\n    height: var(--navbar-height);\n    background-color: var(--color-secondary);\n\n    .shop-name {\n        color: var(--text-light);\n        font-weight: 600;\n        font-size: 20px;\n    }\n}\n\n.navbar-container {\n    $nav-items: 3;\n\n    img {\n        height: var(--navbar-height);\n        padding: 15px;\n    }\n\n    .sense-app {\n        display: flex;\n        flex-direction: row-reverse;\n        gap: 10px;\n\n        a {\n            border: none;\n            padding: 4px 10px;\n            font-size: 12px;\n            border-radius: var(--small-border-radius);\n            display: flex;\n            align-items: center;\n            gap: 4px;\n            box-shadow: var(--light-box-shadow);\n            white-space: nowrap;\n            background-color: var(--color-primary);\n            color: var(--text-light);\n            text-decoration: none;\n        }\n\n\n\n    }\n\n    width: 100%;\n    height: var(--navbar-height);\n    position: relative;\n    background-color: var(--navbar-color);\n    display: flex;\n    align-items: center;\n    // justify-content: center;\n    top: 0;\n    display: grid;\n    grid-template-columns: 1fr auto 1fr;\n\n    .list {\n        display: flex;\n        width: 100%;\n\n        li {\n            position: relative;\n            list-style: none;\n            width: var(--navbar-height);\n            height: var(--navbar-height);\n            z-index: 1;\n\n            a {\n                position: relative;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                flex-direction: column;\n                width: 100%;\n                text-align: center;\n\n\n                .icon {\n                    position: relative;\n                    display: block;\n                    text-align: center;\n                    transition: 0.5s;\n                    color: var(--text-light);\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    height: var(--navbar-height);\n\n                    svg {\n                        fill: currentColor;\n                        width: var(--svg-width);\n                        height: var(--svg-width);\n                    }\n                }\n\n                .text {\n                    position: absolute;\n                    color: var(--background-color);\n                    color: var(--text-light);\n\n\n                    font-weight: 400;\n                    font-size: var(--text-font-size);\n                    letter-spacing: 0.05rem;\n                    transition: 0.5s;\n                    opacity: 0;\n                    transform: translateY(-25px);\n                }\n\n                &.active {\n                    .icon {\n                        transform: translateY(var(--icon-translate-y));\n                        color: var(--background-color);\n                    }\n\n                    .text {\n                        opacity: 1;\n                        transform: translateY(-15px);\n                    }\n                }\n            }\n\n            @for $i from 1 through $nav-items {\n                &:nth-child(#{$i}):has(.active)~.indicator {\n                    transform: translateX(calc(var(--navbar-height) * calc(#{$i} - 1)));\n                }\n            }\n        }\n    }\n\n    .indicator {\n        position: absolute;\n        width: var(--navbar-height);\n        height: var(--navbar-height);\n        background-color: var(--indicator-color);\n        bottom: -50%;\n        border-radius: 50%;\n        border: 6px solid var(--background-color);\n        transition: 0.5s;\n\n\n        &::before,\n        &::after {\n            content: '';\n            position: absolute;\n            bottom: 50%;\n            width: 20px;\n            height: 20px;\n            background-color: transparent;\n\n        }\n\n        &::before {\n            left: -22px;\n            box-shadow: 1px 10px 0 0 var(--background-color);\n            border-bottom-right-radius: 20px;\n        }\n\n        &::after {\n            right: -22px;\n            box-shadow: -1px 10px 0 0 var(--background-color);\n            border-bottom-left-radius: 20px;\n        }\n    }\n}\n\n.whatsapp {\n    position: fixed;\n    bottom: 50px;\n    right: 50px;\n    width: 50px;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #25D366;\n    border-radius: 50%;\n    // border-top-right-radius: 5px;\n    color: white;\n    font-size: 30px;\n}",".input-container {\n  position: relative;\n  width: 100%;\n  font-size: 17px;\n  padding-top: var(--label-hight);\n\n  input {\n    width: 100%;\n    padding: var(--input-padding);\n    border: 1px solid var(--table-border-color);\n    border-radius: var(--small-border-radius);\n    outline: none;\n    transition: all 150ms ease-in-out;\n\n    &:focus {\n      // border: 1px solid var(--primary-color);\n    }\n\n    &.disabled + label,\n    &:valid + label,\n    &:focus + label {\n      top: 0;\n      color: var(--text-dark);\n      font-weight: var(--bold);\n      font-size: var(--label-hight);\n      padding: 0 5px;\n    }\n  }\n  padding-top: var(--label-hight);\n\n  .timezone-container {\n\twidth: fit-content;\n  }\n\n  .timezone-select {\n\tfont-size: 14px;\n    max-width: 400px;\n\tpadding: 2px 10px;\n    border: 1px solid var(--table-border-color);\n    border-radius: var(--small-border-radius);\n    outline: none;\n    transition: all 150ms ease-in-out;\n\n    &:focus {\n      // border: 1px solid var(--primary-color);\n    }\n\n    &.disabled + label,\n    &:valid + label,\n    &:focus + label {\n      top: 0;\n      color: var(--text-dark);\n      font-weight: var(--bold);\n      font-size: var(--label-hight);\n      padding: 0 5px;\n    }\n  }\n\n  .timezone-option {\n\tfont-size: 14px;\n  }\n\n  .timezone-dropdownIndicator {\n\tpadding: 4px\n  }\n\n  label {\n    padding: var(--input-padding);\n    position: absolute;\n    width: 100%;\n    left: 0;\n    text-align: start;\n    cursor: text;\n    transition: all 150ms ease-in-out;\n    color: var(--text-dark-secondary);\n    // color: var(--table-border-color);\n    top: var(--label-hight);\n    z-index: 2;\n  }\n}\n",".loader {\n    display: inline-block;\n    position: relative;\n    width: 80px;\n    height: 80px;\n    margin: 0 auto;\n\n    div {\n        box-sizing: border-box;\n        display: block;\n        position: absolute;\n        width: 64px;\n        height: 64px;\n        margin: 8px;\n        border: 8px solid var(--color-primary);\n        border-radius: 50%;\n        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n        border-color: var(--color-primary) transparent transparent transparent;\n\n        &:nth-child(1) {\n            animation-delay: -0.45s;\n        }\n\n        &:nth-child(2) {\n            animation-delay: -0.3s;\n        }\n\n        &:nth-child(3) {\n            animation-delay: -0.15s;\n        }\n    }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n@keyframes lds-ring {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}","footer {\n    text-align: center;\n    background-color: var(--color-secondary);\n    justify-self: flex-end;\n    height: var(--footer-height);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n\n    a {\n        color: white;\n        text-decoration: none;\n    }\n}",".loader-page {\n    min-height: calc(100% - var(--footer-height));\n\n    text-align: center;\n}",".switch {\n    input[type='checkbox'] {\n        opacity: 0;\n        position: absolute;\n        transform: scale(0);\n\n        &:disabled+label {\n            opacity: 0.5;\n\n        }\n\n        &:focus+label::before {\n            box-shadow: var(--light-box-shadow);\n        }\n\n        &+label {\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n            position: relative;\n\n            &::before,\n            &::after {\n                content: '';\n                border-radius: 1.5em;\n                transition: all 150ms ease-in-out;\n            }\n\n            &::before {\n                width: 4em;\n                height: 2em;\n                background-color: var(--color-primary);\n                margin-inline-end: 0.25em;\n            }\n\n            &::after {\n                width: 1.8em;\n                height: 1.8em;\n                left: 0.2em;\n                background-color: var(--color-secondary);\n                position: absolute;\n            }\n        }\n\n        &:checked+label {\n\n            &::before {\n                background-color: var(--color-secondary);\n            }\n\n            &::after {\n                background-color: var(--color-primary);\n                transform: translateX(100%);\n            }\n        }\n    }\n}",".tooltip-container {\n\t--icon-width: 15px;\n\t--arrow-size: 10px;\n\t--scale: 0;\n\t--text-secondary-color: white;\n\t--info: #242425;\n\t--gap: 5px;\n\n\tbackground-color: var(--info);\n\tposition: relative;\n\tdisplay: inline-block;\n\twidth: var(--icon-width);\n\theight: var(--icon-width);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 50%;\n\tcolor: var(--text-secondary-color);\n\t// border: 1px solid white;\n\n\tsvg {\n\t\tfont-size: 10px;\n\t}\n\n\t&::before {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\tborder: var(--arrow-size) solid transparent;\n\t\tright: 50%;\n\t\t// transition: transform var(--duarition-time) var(--duarition-effect);\n\t}\n\n\t.tooltip {\n\t\t// transition: all var(--duarition-time) var(--duarition-effect);\n\t\tborder-radius: var(--small-border-radius);\n\t\t// left: 50%;\n\t\tpadding: var(--gap);\n\t\tbackground-color: var(--info);\n\t\tposition: absolute;\n\t\ttransform: scale(var(--scale));\n\t\tmax-width: 300px;\n\t\twidth: max-content;\n\t\tz-index: 999;\n\t\ttext-align: center;\n\t\tfont-size: 16px;\n\t}\n\n\t&.center .tooltip {\n\t\tleft: 50%;\n\t\ttransform: translateX(-50%) scale(var(--scale));\n\t}\n\n\t&.right .tooltip {\n\t\tright: 0;\n\t\ttransform: scale(var(--scale));\n\t}\n\n\t&.left .tooltip {\n\t\tleft: 0;\n\t\ttransform: scale(var(--scale));\n\t}\n\n\t&.bottom {\n\t\t&::before {\n\t\t\ttransform: translateX(50%) translateY(calc(5px + var(--arrow-size)))\n\t\t\t\tscale(var(--scale));\n\t\t\tbottom: 0;\n\t\t\tborder-bottom-color: var(--info);\n\t\t}\n\n\t\t.tooltip {\n\t\t\t// transform-origin: top center;\n\t\t\ttop: calc(var(--icon-width) + 5px + var(--arrow-size));\n\t\t}\n\t}\n\n\t&.top {\n\t\t&::before {\n\t\t\ttransform: translateX(50%)\n\t\t\t\ttranslateY(calc(-5px - var(--arrow-size))) scale(var(--scale));\n\t\t\ttop: 0;\n\t\t\tborder-top-color: var(--info);\n\t\t}\n\n\t\t.tooltip {\n\t\t\t// transform-origin: top center;\n\t\t\tbottom: calc(var(--icon-width) + 5px + var(--arrow-size));\n\t\t}\n\t}\n\n\t&.top,\n\t&.bottom {\n\t\t--scale: 1;\n\t}\n}\n",".select {\n    position: relative;\n    min-width: 20em;\n    width: 100%;\n    min-height: 1.5em;\n    border: 1px solid var(--light-grey);\n    display: flex;\n    align-items: center;\n    gap: .5em;\n    padding: .5em;\n    border-radius: var(--small-border-radius);\n    outline: none;\n    margin-top: calc(var(--label-hight) + 2px);\n\n    &*:focus {\n        border-color: var(--primary-color);\n    }\n\n    .value {\n        flex-grow: 1;\n        display: flex;\n        gap: .5em;\n        flex-wrap: wrap;\n    }\n\n    .filter-input,\n    .placeholder {\n        border: none;\n        outline: none;\n        flex-grow: 1;\n        display: flex;\n        gap: .5em;\n        flex-wrap: wrap;\n    }\n\n    .placeholder {\n        opacity: 0.5;\n        position: absolute;\n        transition: all var(--animation-duration) var(--animation-timing-curve);\n        top: 0.7rem;\n\n        &.top {\n            top: calc(var(--label-hight) * -1 - 2px);\n            font-size: var(--label-hight);\n            font-weight: var(--bold);\n            opacity: 1;\n        }\n\n    }\n\n    .clear-btn {\n        background: none;\n        color: var(--light-grey);\n        border: none;\n        outline: none;\n        cursor: pointer;\n        padding: 0;\n        font-size: 1.25em;\n\n        &:hover,\n        &:focus {\n            color: var(--medium-grey);\n        }\n    }\n\n    .divider {\n        background-color: var(--light-grey);\n        align-self: stretch;\n        width: .05em;\n    }\n\n    .caret {\n        translate: 0 25%;\n        border: .25em solid transparent;\n        border-top-color: var(--light-grey);\n    }\n\n    .options {\n        position: absolute;\n        margin: 0;\n        padding: 0;\n        list-style: none;\n        display: none;\n        max-height: 15em;\n        overflow-y: auto;\n        border: .05em solid var(--light-grey);\n        border-radius: .25em;\n        width: 100%;\n        left: 0;\n        top: calc(100% + .25em);\n        background-color: white;\n        z-index: 100;\n\n        &.show {\n            display: block;\n        }\n\n        .option {\n            padding: .25em .5em;\n            cursor: pointer;\n\n            &.selected {\n                background-color: hsl(200, 100%, 70%);\n            }\n\n            &.highlighted {\n                background-color: hsl(200, 100%, 50%);\n                color: white\n            }\n        }\n    }\n\n    .selected-option {\n        display: flex;\n        align-items: center;\n        border: .05em solid var(--light-grey);\n        border-radius: .25em;\n        padding: .15em .25em;\n        gap: .25em;\n        cursor: pointer;\n        background: none;\n        outline: none;\n\n        &>.remove-btn {\n            font-size: 1.25em;\n            color: var(--light-grey);\n        }\n\n        &:hover,\n        &:focus {\n            background-color: hsl(0, 100%, 90%);\n            border-color: hsl(0, 100%, 50%);\n\n            &>.remove-btn {\n                color: hsl(0, 100%, 50%);\n\n            }\n\n        }\n    }\n}",".dropdown-container {\n    position: relative;\n    width: max-content;\n\n    .toggele-dropdown-button {\n        border: none;\n        background-color: white;\n        padding: 10px;\n        box-shadow: var(--light-box-shadow);\n        border-radius: var(--small-border-radius);\n\n        &:has(.text) {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 10px;\n        }\n    }\n\n\n    .dropdown {\n        position: absolute;\n        padding: 9px 0;\n        max-width: 340px;\n        min-width: 200px;\n        background-color: white;\n        box-shadow: var(--light-box-shadow);\n        top: 100%;\n        left: 0;\n        z-index: 10;\n        border-radius: var(--small-border-radius);\n        transform: scale(0);\n        transition: transform var(--animation-duration) var(--animation-timing-curve);\n        transform-origin: top left;\n\n        &.open {\n            transform: scale(1);\n        }\n\n        .menu-item {\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            line-height: 14.5px;\n            width: 100%;\n            padding: 10px 10px;\n            text-align: start;\n            border: none;\n            background-color: transparent;\n            cursor: pointer;\n            text-transform: capitalize;\n\n            &:hover {\n                background-color: rgba(0, 0, 0, 0.2);\n            }\n\n        }\n    }\n}",".checkbox-container {\n    display: flex;\n    align-items: center;\n    position: relative;\n\n    --light-grey: #999;\n    --primary-color: #fe7900;\n    --lightest-grey: #fff;\n\n\n    label {\n        cursor: pointer;\n        display: flex;\n\n        &::before {\n            content: '';\n            width: 1em;\n            height: 1em;\n            border-radius: var(--small-border-radius);\n            margin-right: .5em;\n            border: .05em solid var(--light-grey);\n        }\n    }\n\n    label:hover::before,\n    input[type='checkbox']:hover+label::before {\n        background-color: var(--primary-color);\n        border: 1px solid var(--primary-color);\n    }\n\n    input[type='checkbox'] {\n        cursor: pointer;\n        opacity: 0;\n        position: absolute;\n\n        &:focus+label::before {\n            box-shadow: var(--light-box-shadow);\n        }\n\n        &:disabled,\n        &:disabled+label {\n            color: var(--light-grey);\n            cursor: default;\n\n            &::before {\n                background-color: var(--lightest-grey);\n                border-color: #999;\n            }\n        }\n\n        &:checked+label {\n\n            &::after {\n                content: '';\n                position: absolute;\n                left: 10px;\n                width: 12px;\n                height: 6px;\n                border-bottom: 3px solid var(--lightest-grey);\n                border-left: 3px solid var(--lightest-grey);\n                transform: translate(2px, 4px) rotate(-45deg);\n                border-radius: var(--small-border-radius);\n\n            }\n\n            &::before {\n                background-color: var(--primary-color);\n                border: 1px solid var(--primary-color);\n            }\n        }\n    }\n}",".notifications-container {\n    position: fixed;\n    z-index: 10;\n    right: 10px;\n    top: 90px;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n\n    --error: #ff0000;\n    --warning: #ff9f00;\n    --success: #00ff00;\n\n    .notification {\n        text-align: start;\n        padding: 1rem;\n        color: white;\n        border-radius: var(--small-border-radius);\n        width: 300px;\n        box-shadow: var(--dark-box-shadow);\n        display: flex;\n        gap: 16px;\n        align-items: flex-start;\n\n        svg {\n            color: white;\n            font-size: 2rem;\n            margin-top: 4px;\n        }\n\n        .content {\n            display: flex;\n            flex-direction: column;\n            gap: 4px;\n            text-align: start;\n\n            .title {\n                font-weight: var(--bold);\n                text-align: start;\n            }\n        }\n\n        &.error {\n            background-color: var(--error);\n        }\n\n        &.warning {\n            background-color: var(--warning);\n        }\n\n        &.success {\n            background-color: var(--success);\n        }\n\n        &.info {\n            background-color: var(--info);\n        }\n    }\n}",".context-menu-container {\n    // transform: translateX(-100%);\n    position: fixed;\n    padding: 9px 0;\n    max-width: 340px;\n    min-width: 200px;\n    background-color: white;\n    box-shadow: var(--light-box-shadow);\n    top: 0;\n    left: 0;\n    z-index: 10;\n    padding: 10px;\n    border-radius: var(--big-border-radius);\n    animation-name: show;\n    animation-duration: 150ms;\n    max-height: 300px;\n    overflow-y: auto;\n\n\n\n    .menu-item {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        line-height: 14.5px;\n        width: 100%;\n        padding: 10px 10px;\n        text-align: start;\n        border: none;\n        background-color: transparent;\n        display: block;\n    }\n}\n\n@keyframes show {\n    from {\n        scale: 0;\n    }\n\n    to {\n        scale: 1;\n    }\n}",".accordion {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n\n    .accordion-item {\n        padding: 10px 20px;\n        background-color: white;\n        // color: white;\n        border-radius: var(--big-border-radius);\n\n        &.open {\n            .title svg {\n                transform: rotate(225deg);\n            }\n\n            .content {\n                max-height: 9999px;\n                font-size: 1rem;\n                opacity: 1;\n                padding: 10px 0;\n            }\n        }\n\n        .title {\n            font-weight: var(--bold);\n            font-size: 1.5rem;\n            padding: 20px 0;\n            display: flex;\n            justify-content: space-between;\n            cursor: pointer;\n\n            svg {\n                transition: transform 150ms ease-in-out;\n            }\n        }\n\n        .content {\n            word-break: keep-all;\n            max-height: 0;\n            transition: all 150ms ease-in-out;\n            overflow: hidden;\n            font-size: 0;\n            opacity: 0;\n            padding: 0;\n        }\n    }\n\n\n}","#root {\n\toverflow-y: overlay;\n}\n\n.modal {\n  margin: auto;\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.modal-backdrop {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  background: #000000bb;\n  align-items: center;\n  justify-content: center;\n  overflow-y: hidden;\n  z-index: 1001;\n\n  transition: 0.2s;\n  display: none;\n\n  &.show {\n    display: flex;\n  }\n}\n\n.modal.enter-done {\n  opacity: 1;\n  pointer-events: visible;\n}\n\n.modal.exit {\n  opacity: 0;\n}\n\n.modal-content {\n  width: 500px;\n  padding: 10px;\n  border-radius: var(--big-border-radius);\n  font-size: 20px;\n  align-items: center;\n  background-color: white;\n  box-shadow: var(--light-box-shadow);\n}\n\n.modal.enter-done .modal-content {\n  transform: translateY(0);\n}\n\n.modal.exit .modal-content {\n  transform: translateY(-200px);\n}\n\n.modal-header,\n.modal-footer {\n  padding: 10px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  & .close-modal {\n    cursor: pointer;\n    font-size: 20px;\n    color: var(--primary-color);\n  }\n\n  & > button {\n    padding: 10px;\n    gap: 10px;\n    align-items: center;\n    // background-color: white;\n  }\n}\n\n.modal-title {\n  margin: 0;\n}\n\n.modal-body {\n  padding: 10px;\n  border-top: 1px solid #eee;\n  text-align: center;\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n\n  & > button {\n    padding: 10px;\n    gap: 10px;\n    align-items: center;\n  }\n\n  //   border-bottom: 1px solid #eee;\n}\n",".dashboard-page {\n\n    .title {\n        display: block;\n        padding-bottom: 10px;\n        font-weight: 600;\n\n    }\n\n    .placeholder {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        border-radius: var(--small-border-radius);\n\n\n        svg {\n            width: 130px;\n            height: 130px;\n            background-color: var(--background-color);\n            margin-bottom: 20px;\n            padding: 40px;\n            border-radius: 50%;\n            color: var(--text-dark-secondary);\n        }\n\n        span {\n            color: var(--text-dark);\n\n            &.error {\n                color: red;\n            }\n\n            // font-weight: 600;\n        }\n    }\n\n    .custom-tooltip {\n        background-color: white;\n        padding: 10px;\n        max-width: 200px;\n\n        .content {\n            word-break: break-all;\n        }\n    }\n\n    .areaMultiLine-container {\n        display: grid;\n        gap: 20px;\n        grid-template-columns: repeat(3, minmax(0, 1fr));\n    }\n}",".no-shop-page {\n    font-size: 2rem;\n\n    img {\n        max-width: 300px;\n    }\n\n    span {\n        text-align: center;\n    }\n}\n\n.main-container:has(> .page.no-shop-page) {\n    min-height: calc(100% - var(--footer-height));\n}",".plans-page {\n    .wa-container {\n        position: relative;\n    }\n\n    .pay-time-container {\n\n        display: grid;\n        grid-template-columns: 1fr auto 1fr;\n        gap: 1rem;\n        align-items: center;\n\n        span:nth-child(1) {\n            text-align: end;\n        }\n\n        .monthly {\n            font-weight: 600;\n            // color: var(--color-secondary);\n        }\n\n        .yearly {\n            font-weight: 600;\n            // color: var(--color-primary);\n        }\n    }\n\n\n    .plans-container {\n        display: grid;\n        grid-template-columns: 1fr 1fr 1fr 1fr;\n        gap: 2rem;\n        position: relative;\n        padding: 1rem 3rem;\n\n\t\t.black-friday {\n\t\t\tbackground-color: #000;\n\t\t\tcolor: #fff;\n\t\t}\n\t\t\n        .plan {\n            position: relative;\n            z-index: 1;\n            box-shadow: var(--light-box-shadow);\n            padding: 24px;\n            border-radius: var(--big-border-radius);\n            // background-color: white;\n            padding-top: 80px;\n\n\t\t\t\n\n            .title {\n                display: block;\n                font-size: 1.7rem;\n                font-weight: 800;\n                margin-bottom: .2rem;\n                text-transform: capitalize;\n\n                &.free {\n                    margin-bottom: 37px;\n                }\n            }\n\n            .price-mo {\n                display: block;\n                font-weight: 600;\n                color: var(--color-primary);\n\n                .price {\n                    font-size: 1.5rem;\n                }\n            }\n\n\n\n            .plan-btn {\n                background-color: var(--color-primary);\n                width: 100%;\n                font-size: 1.2rem;\n                color: white;\n                font-weight: 600;\n                border-radius: var(--big-border-radius);\n                border: none;\n                padding: .7rem;\n                margin: 1rem 0;\n            }\n\n            .yearly-price {\n                width: 100%;\n                display: block;\n                text-align: center;\n                margin-top: 1rem;\n                font-size: 0.8rem;\n                color: var(--text-dark-secondary);\n\n                .price {\n                    font-size: 1rem;\n                }\n            }\n\n            .features {\n                display: flex;\n                flex-direction: column;\n                gap: 5px;\n\n                .feature {\n\n                    position: relative;\n                    padding-left: 35px;\n\n                    &:after {\n                        content: '';\n                        display: block;\n                        position: absolute;\n                        top: -1px;\n                        left: 10px;\n                        width: 8px;\n                        height: 16px;\n                        border: solid var(--color-primary);\n                        border-width: 0 4px 4px 0;\n                        transform: rotate(45deg);\n                        border-radius: 0.29rem;\n                    }\n                }\n            }\n\n\n            &.curr {\n                position: relative;\n\n                .plan-btn {\n                    background-color: transparent;\n                    color: var(--wa-text-primary);\n                    pointer-events: none;\n                }\n\n                &::before {\n                    content: \"CURRENT\";\n                    position: absolute;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    top: 0;\n                    left: 0;\n                    width: 100%;\n                    text-align: center;\n                    height: 50px;\n                    background-color: var(--color-primary);\n                    border-top-left-radius: var(--big-border-radius);\n                    border-top-right-radius: var(--big-border-radius);\n                    color: white;\n                }\n            }\n\n            &.most-popular {\n                position: relative;\n\n\n                &::before {\n                    content: \"MOST POPULAR\";\n                    position: absolute;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    top: 0;\n                    left: 0;\n                    width: 100%;\n                    text-align: center;\n                    height: 50px;\n                    background-color: var(--color-secondary);\n                    border-top-left-radius: var(--big-border-radius);\n                    border-top-right-radius: var(--big-border-radius);\n                    color: white;\n                }\n            }\n\n            &.black-friday {\n                position: relative;\n\n\n                &::before {\n                    content: \"BLACK FRIDAY\";\n                    position: absolute;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    top: 0;\n                    left: 0;\n                    width: 100%;\n                    text-align: center;\n                    height: 50px;\n                    background-color: var(--color-secondary);\n                    border-top-left-radius: var(--big-border-radius);\n                    border-top-right-radius: var(--big-border-radius);\n                    color: 000;\n\t\t\t\t\tbackground-color: var(--color-primary);\n                }\n            }\n        }\n    }\n}",".home-page {\n\t.totals-utm {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr 1fr 1fr;\n\t\tgap: 16px;\n\n\t\t.container {\n\t\t\tpadding: 10px;\n\t\t\tborder-radius: var(--big-border-radius);\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 10px;\n\t\t\tfont-size: 20px;\n\t\t\talign-items: center;\n\t\t\tbackground-color: white;\n\t\t\tbox-shadow: var(--light-box-shadow);\n\n\t\t\tspan:nth-child(1) {\n\t\t\t\tfont-weight: 600;\n\t\t\t}\n\t\t}\n\t}\n\t.filters {\n\t\t// position: absolute;\n\t\t// top: 20px;\n\t\twidth: 100%;\n\n\t\t.date-picker-with-button {\n\t\t\tposition: static;\n\t\t\tpadding-top: 12px;\n\t\t}\n\n\t\t.search-container {\n\t\t\tdisplay: flex;\n\t\t\tposition: relative;\n\t\t\tmin-width: 310px;\n\n\t\t\t.input-container {\n\t\t\t\tlabel {\n\t\t\t\t\tpadding-inline-start: 40px;\n\t\t\t\t}\n\n\t\t\t\tinput {\n\t\t\t\t\tborder-radius: var(--big-border-radius);\n\t\t\t\t\tpadding-inline-start: 40px;\n\t\t\t\t\t// border-top-left-radius: 0;\n\t\t\t\t\t// border-bottom-left-radius: 0;\n\t\t\t\t\t// box-shadow: none;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.svg-container {\n\t\t\t\t// border-top-left-radius: var(--big-border-radius);\n\t\t\t\t// border-bottom-left-radius: var(--big-border-radius);\n\t\t\t\t// margin-top: 12px;\n\t\t\t\t// display: flex;\n\t\t\t\t// align-items: center;\n\t\t\t\t// justify-content: center;\n\t\t\t\t// background-color: white;\n\t\t\t\t// width: 50px;\n\t\t\t\t// color: white;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 10px;\n\t\t\t\tz-index: 10;\n\t\t\t\ttop: 50%;\n\t\t\t\ttransform: translateY(calc(-50% + 6px));\n\t\t\t}\n\t\t}\n\t}\n\n\t.table-tooltip {\n\t\tposition: absolute;\n\t\tbackground-color: var(--color-secondary);\n\t\tcolor: var(--text-light);\n\t\tpadding: 10px;\n\t\tleft: 50%;\n\t\topacity: 0;\n\t\tpointer-events: none;\n\t\tz-index: 100;\n\t\ttop: -10px;\n\t\ttransform: translateY(-100%) translateX(-50%);\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t\tborder-radius: var(--small-border-radius);\n\t\tdisplay: none;\n\n\t\t&.show {\n\t\t\tdisplay: flex;\n\t\t}\n\n\t\t&::before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\tbottom: -10px;\n\t\t\t// width: 10px;\n\t\t\t// height: 10px;\n\t\t\tborder: 5px solid transparent;\n\t\t\tborder-top-color: var(--color-secondary);\n\t\t\t// background-color: var(--color-secondary);\n\t\t\tleft: calc(50% - 5px);\n\t\t}\n\t}\n\n\t// .limit-plan {\n\t//     margin-top: 40px;\n\t// }\n\n\t// .explan {\n\t//     margin-top: 40px;\n\t// }\n\n\t.export {\n\t\tpadding: 10px;\n\t\tgap: 10px;\n\t\talign-items: center;\n\t\tbackground-color: white;\n\t}\n\n\ttd:has(.table-tooltip) {\n\t\toverflow: unset !important;\n\t\tposition: relative;\n\n\t\t&:hover {\n\t\t\t.table-tooltip {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n}\n",".order-page {\n    .orders-utm {\n        display: grid;\n        grid-template-columns: 1fr 1fr 1fr;\n        gap: 16px;\n\n        .container {\n            padding: 10px;\n            border-radius: var(--big-border-radius);\n            display: flex;\n            flex-direction: column;\n            gap: 10px;\n            font-size: 20px;\n            align-items: center;\n            background-color: white;\n            box-shadow: var(--light-box-shadow);\n\n            span:nth-child(1) {\n                font-weight: 600;\n            }\n        }\n    }\n\n    .back {\n        text-decoration: none;\n        color: black;\n        background-color: var(--color-primary);\n        border: none;\n        color: white;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 10px;\n        box-shadow: var(--light-box-shadow);\n        border-radius: var(--small-border-radius);\n        gap: 10px;\n        width: max-content;\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
